import Radio from "@mui/material/Radio";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { auto } from "@popperjs/core";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { parseGooglePlace } from "../../utils/helpers/addressHelper";
import { EditorState, convertToRaw, RichUtils } from "draft-js";
import {
  AiFillPlusCircle,
  AiOutlineCloseCircle,
  AiOutlinePlus,
} from "react-icons/ai";
import { BsChevronDown, BsX } from "react-icons/bs";
import { RiDeleteBinLine } from "react-icons/ri";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { default as style, default as styled } from "styled-components";
import Addiocn from "../../assets/icons/Addicon (2).svg";
import plusIcon from "../../assets/icons/Plus.svg";
import Binclr from "../../assets/icons/Bin - Copy.svg";
import Calendericon from "../../assets/icons/Calendar with interaction.svg";
import actinfoblack from "../../assets/icons/Document-3.svg";
import actinfo from "../../assets/icons/Document-321 - Copy.svg";
import actfilter from "../../assets/icons/Filter contacts.svg";
import docicons from "../../assets/icons/Group 2949.svg";
import Taskicon from "../../assets/icons/Group 2951.svg";
import Minusicon from "../../assets/icons/Minus icon.svg";
import Plusicon from "../../assets/icons/Plus.svg";
import actclip from "../../assets/icons/clipboard.svg";
import actfold from "../../assets/icons/folder.svg";
import image2 from "../../assets/icons/Group 3323.svg";
import image3 from "../../assets/icons/Group 3324.svg";
import foldblue from "../../assets/icons/folderblue.svg";
import taskIcon from "../../assets/icons/taskIcon.svg";
import AppDatePicker from "../../components/Common/AppDatePicker";
import DeletePopUp from "../../components/Dailogs/DeletePopUp";
import TasDelete from "../../components/Dailogs/TaskDelete";
import DocumentUploaderWithProgress from "../../components/Common/Document_Uploader_With_Progress";
import Header from "../../layouts/Header";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import {
  AddComments,
  AddCompanyContact,
  AddContact,
  AddDocToUserContacts,
  AddTagsContact,
  DeleteDocs,
  DeleteTags,
  EmptyProductPart,
  FetchAddTagsContact,
  FetchContactById,
  FetchDocsContactById,
  FetchManagersList,
  FetchSearchClients,
  RemoveDocsClientById,
  UpdateContacts,
  deleteTask,
  fetchTaskByContactId,
  updateTaskStatus2,
  GlobalRequest,
} from "../../redux/actions/action";
import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
import {
  API_URL,
  CHAT_API_URL,
  ADD_CONTACTS,
  UPDATE_CONTACTS,
} from "../../redux/constants/type";
import "../../assets/styles/local/Addcontact.css";
import { getLocalFormatedTime } from "../../utils/helpers/calculateTime";
import { AppInputBelowDropDown } from "../../utils/helpers/dropdown";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { ROLES, isNotRole, isRole } from "../../utils/helpers/userRole";
import ContactTaskModal from "../dynamic/ContactTaskModal";
import AddTaskModal from "../../components/Dailogs/AddTaskModal";
import { ContactEmails } from "./ContactEmails";
import { OutlookContactEmails } from "./OutlookContactEmails";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { EyeOutlined } from "@ant-design/icons";
import { getFilePreview } from "../../utils/filePreview/filePreview";
import FilePreviewModal from "../../utils/filePreview/FilePreviewModal";
import { v4 as uuidv4 } from "uuid";

const AddContacts = () => {
  const inputRef = useRef(null);
  const roleAccess = window.localStorage.getItem("roleid");
  const packageID = window.localStorage.getItem("packageId");
  const currentCompanyId = useMemo(() =>
    window.localStorage.getItem("companyId"),
  );
  const currentUserId = window.localStorage.getItem("userid");
  const selectedGroupId = window.localStorage.getItem("selectedGroupId");

  const dispatch = useDispatch();
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const passedState = location.state;
  const [emailSource, setEmailSource] = useState("gmail");

  const addContactResponse = useSelector((state) => state.user.AddContacts);
  const addTaskResponse = useSelector((state) => state.user.addTaskResponse);

  const [showAccountManagerDrop, setShowAccountManagerDrop] = useState(false);
  const [showRelationShipDrop, setShowRelationShipDrop] = useState(false);
  const [showPriorityDrop, setShowPriorityDrop] = useState(false);
  const [priority, setPriority] = useState("Medium");
  const [priorityId, setPriorityId] = useState(
    "08da8a3e-d43a-40b9-845d-ba8c2e749694",
  );

  const [filePreview, setFilePreview] = useState(null);

  const [removeaddbtn, setRemoveaddbtn] = useState(false);
  const [changeComp, setChangeComp] = useState("");
  const [jobname, setJobname] = useState("");
  const [reRenderAPI, setReRenderAPI] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteDocument, setDeleteDocument] = useState(false);
  const [deleteRowIndex, setDeleteRowIndex] = useState(null);
  const [searchingClients, setSearchingClients] = useState([]);
  const [canGoBack, setCanGoBack] = useState(false);
  const deletedocResponsedata = useSelector(
    (state) => state?.user?.DeleteDocsdata,
  );
  const updateContactResponse = useSelector(
    (state) => state.user.UpdateContactsdata,
  );
  const singleContactResponse = useSelector(
    (state) => state.user.FetchContactByIddata,
  );
  const fetchAllTags = useSelector(
    (state) => state.user.FetchAddTagsContactdata,
  );
  const getTaskStatusListRes = useSelector(
    (state) => state.user.getTaskStatusListRes,
  );

  const addTagResponse = useSelector((state) => state.user.AddTagsContact);
  const fetchAllManagers = useSelector((state) => state.user.FetchManagersList);
  const AddDocToUserContactsRes = useSelector(
    (state) => state.user.AddDocToUserContacts,
  );
  const searchClientResponse = useSelector(
    (state) => state.user.FetchSearchClientsdata,
  );
  const deleteTaskResponse = useSelector(
    (state) => state.user.deleteTaskResponse,
  );
  const updateTaskStatusResponse = useSelector(
    (state) => state.user.updateTaskStatusResponse,
  );
  const fetchContactTaskResponse = useSelector(
    (state) => state.user.fetchContactTaskResponse,
  );
  const docsContactListResponse = useSelector(
    (state) => state.user.FetchDocsContactByIdData,
  );
  const linkOrAddClientResponse = useSelector(
    (state) => state.user.AddCompanys,
  );
  const firstupname = window.localStorage.getItem("firstname");
  const lastupname = window.localStorage.getItem("lastname");

  const [popups, setPopups] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [clientSearch, setClientSearch] = useState("");
  let hiddenFileInput = useRef(null);
  const primaryColor = useMemo(() =>
    window.localStorage.getItem("primarycolor"),
  );
  const [contactType, setContactType] = useState("Prospect");
  const [activeHeading, setActiveHeading] = useState("1");
  const [docAdded, setDocAdded] = useState(false);
  const selectDoc = useRef(null);
  const [showDropPeople, setShowDropPeople] = useState(false);
  const [filterDrop, setFilterDrop] = useState(false);
  const userid = window.localStorage.getItem("userid");
  const companyId = window.localStorage.getItem("companyId");
  const companyids = window.localStorage.getItem("companyid");
  const [singleContact, setSingleContact] = useState();
  const [tagList, setTagList] = useState([]);
  const [showTagDrop, setShowTagDrop] = useState(false);
  const [managerList, setManagerList] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);

  const [disableBtn, setDisableBtn] = useState(true);
  const [completeTags, setCompleteTags] = useState([]);
  const [docPeopleList, setDocPeopleList] = useState([]);
  const [contactDocsList, setContactDocsList] = useState([]);
  const [docAccessList, setDocAccessList] = useState([]);
  const [showTaskColumn, setShowTaskColumn] = useState(false);
  const [showMaritalStatusDrop, setShowMaritalStatusDrop] = useState(false);
  const [hours, setHours] = useState("00");
  const [minutes, setMinutes] = useState("00");
  const [searchPeople, setSearchPeople] = useState("");
  const [taggedUser, setTaggedUser] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalFunctionNoty, setModalFunctionNoty] = useState("");
  const [show, setShow] = useState([]);
  const [modalFunction, setModalFunction] = useState("");
  const [from, setFrom] = useState(moment().toDate());
  const [taskid, setTaskid] = useState("");
  const [searchText, setSearchText] = useState("");
  const TaskId = window.localStorage.getItem("taskid");
  const [comments, setComments] = useState([]);
  const [maxComments, setMaxComments] = useState([]);
  const [enablecomm, setEnableComm] = useState(false);
  const [showcmnt, setShowcmnt] = useState(true);
  const [length, setLength] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const [message, setMessage] = useState("");
  const [minComments, setMinComments] = useState([]);
  const [firstNameComm, setFirstNameComm] = useState("");
  const [lastNameComm, setLastNameComm] = useState("");
  const [currentDate, setcurrentDate] = useState("");
  ///////////////////////////////DATA VALUES STATE///////////////////////////////
  const [fullName, setFullName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [birthDate, setBirthDate] = useState();
  const [relationship, setRelationship] = useState("Representative");
  const [clientVatNumber, setClientVatNumber] = useState("");
  const [amount, setAmount] = useState("");
  const [tagValue, setTagValue] = useState("");
  const [tags, setTags] = useState([]);
  const [notes, setNotes] = useState("");
  const [roleId, setRoleId] = useState("");
  const [selectedValue, setSelectedValue] = React.useState("");
  const [accountManagerId, setAccountManagerId] = useState(
    "00000000-0000-0000-0000-000000000000",
  );
  const storedClientName = window.localStorage.getItem("clientaddname");
  const [clientName, setClientName] = useState(
    typeof storedClientName === "string" ? storedClientName : "",
  );

  useEffect(() => {
    // when we come from companyList.
    if (location?.state?.from === "CompanyList_Screen") {
      setClientName(location?.state?.companyName);
    }
  }, []);

  const [contactID, setContactID] = useState("");

  useEffect(() => {
    // when we come from AddCompany screen.
    if (location?.state?.from === "Company_Screen") {
      setClientName(passedState?.historyCompanyName);
      setContactID(passedState?.historyCompanyID);
    }
  }, []);

  const [connection, setConnection] = useState(null);
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty(),
  );

  const [mainContactType, setMainContactType] = useState("Client");
  const storedClientId = window.localStorage.getItem("clientId2");
  const [clientId, setClientId] = useState(
    typeof storedClientId === "string" ? storedClientId : "",
  );
  const [fileName, setFileName] = useState("");
  const [taskName, setTaskName] = useState("");
  const [description, setDescription] = useState("");
  const [allTasks, setAllTasks] = useState([]);
  const [key, setKey] = useState("home");
  const [dueDate, setDueDate] = useState(new Date());
  const [errorfull, setErrorfull] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [hideDropdown, setHideDropdown] = useState(true);
  const [openCompanyDropdown, setOpenCompanyDropdown] = useState(false);
  const [fulLenghtDocAddContact, setFulLenghtDocAddContact] = useState(false);
  const [contectDoc, setContectDoc] = useState(
    window.localStorage.getItem("Doc"),
  );
  const [marital, setMarital] = useState("Select");
  const [fetchTransAddContactList, setFetchTransAddContactList] = useState({});
  const t = (key) => fetchTransAddContactList?.[key] || "";
  const [dateError, setDateError] = useState(false);
  const [isProcess, setIsProcess] = useState(false);

  const typeoptions = [{ value: "Representative" }, { value: "Employee" }];
  // const typeoptions = [ { value: fetchTransAddContactList[ 24 ]?.translation }, { value: fetchTransAddContactList[ 23 ]?.translation } ];

  const priorityOptions = [
    { label: "Highest", value: "08da8a3e-d43a-40b9-845d-ba8c2e749691" },
    { label: "High", value: "08da8a3e-d43a-40b9-845d-ba8c2e749692" },
    { label: "Low", value: "08da8a3e-d43a-40b9-845d-ba8c2e749693" },
    { label: "Medium", value: "08da8a3e-d43a-40b9-845d-ba8c2e749694" },
  ];

  const mobileTypeoptions = [
    { value: "Professional Address" },
    { value: "Personal Address" },
  ];
  const emailTypeoptions = [
    { value: "Personal Email" },
    { value: "Professional Email" },
  ];
  const mobilePhoneTypeoptions = [
    { value: "Professional Mobile" },
    { value: "Personal Mobile" },
    { value: "Office Number" },
  ];
  const [emails, setEmails] = useState([
    {
      email: "",
      type: "Professional Email",
    },
  ]);
  const [emailErrors, setEmailErrors] = useState([]);
  const validateEmail = (email) => {
    // Regular expression for validating an Email
    const emailRegex = /^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/;
    return emailRegex.test(email);
  };
  const handleEmailChange = (e, index) => {
    const { name, value } = e.target;
    let newEmails = [...emails];
    newEmails[index][name] = value;
    setEmails(newEmails);

    // Validate email and update error state
    let newEmailErrors = [...emailErrors];
    newEmailErrors[index] = !validateEmail(value);
    setEmailErrors(newEmailErrors);
  };

  const [mobiles, setMobiles] = useState([
    {
      phoneNumber: "",
      type: "Professional Mobile",
    },
  ]);

  const [addresses, setAddresses] = useState([
    {
      address: "",
      type: "Professional Address",
      street: "",
      city: "",
      state: "",
      pinCode: "",
      country: "",
    },
  ]);

  const [activityLogs, setActivityLogs] = useState([]);
  const [showFullContent, setShowFullContent] = useState(false);
  const [showIndexContent, setShowIndexContent] = useState();

  const refActivityTimelineDD = useRef();

  useEffect(() => {
    if (fetchContactTaskResponse.status === true) {
      setAllTasks(fetchContactTaskResponse?.data);
    }
  }, [fetchContactTaskResponse]);

  useEffect(() => {
    if (contectDoc) {
      setActiveHeading("2");
      setTimeout(() => {
        window.localStorage.removeItem("Doc");
        setContectDoc(null);
      }, 1000);
    }
  }, [contectDoc]);

  useEffect(() => {
    if (AddDocToUserContactsRes?.status === true) {
      dispatch(FetchDocsContactById(id));
    } else {
      return;
    }
  }, [AddDocToUserContactsRes]);

  useEffect(() => {
    if (deleteTaskResponse.status === true) {
      dispatch(fetchTaskByContactId(id));
    }
  }, [deleteTaskResponse]);

  useEffect(() => {
    if (updateTaskStatusResponse?.status === true) {
      dispatch(fetchTaskByContactId(id));
    }
  }, [updateTaskStatusResponse]);

  useEffect(() => {
    if (addTaskResponse?.status === true) {
      setTimeout(() => {
        dispatch(fetchTaskByContactId(id));
      }, 1000);
    }
  }, [addTaskResponse]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setFilterDrop(false);
  };

  const handleClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };

  const handleDeleteFun = () => {
    setImageUrl("");
    setDeleteModalShow(false);
  };

  const handleDeleteDocumentFun = () => {
    if (deleteRowIndex !== null) {
      dispatch(DeleteDocs(deleteRowIndex));
      let data = [...contactDocsList];
      data.splice(deleteRowIndex, 1);
      setContactDocsList(data);
    }
    setDeleteDocument(false);
    setDeleteRowIndex(null);
  };

  const profileUpload = async (file) => {
    var formData = new FormData();
    formData.append("", file);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      setImageUrl(response.data[0]);
    } catch (error) {}
  };
  const onClickTag = () => {
    inputRef?.current?.focus();
    setShowTagDrop(true);
  };
  const onFileUploaded = (data) => {
    if (isUpdating) {
      let reqArray = [];
      reqArray.push({
        documentname: data[0].name,
        documentextension: data[0].type,
        documentcontent: "string",
        link: data[0].link,
        documentsize: data[0].size,
      });
      dispatch(AddDocToUserContacts(id, userid, reqArray));
    } else {
      const modifiedContacts = contactDocsList;
      modifiedContacts.push({
        userid: userid,
        documentname: data[0].name,
        documentextension: data[0].type,
        documentcontent: "string",
        link: data[0].link,
        documentsize: data[0].size,
      });
      setContactDocsList([...modifiedContacts]);
    }
    setContectDoc("Doc");
  };

  // riya code start for Doc Drag and Drop
  const [isDragging, setIsDragging] = useState(false);

  // Handle file drop
  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const files = event.dataTransfer.files;
    if (files.length > 0) {
      for (const file of files) {
        const data = {
          name: file.name,
          type: file.type,
          size: file.size,
          link: URL.createObjectURL(file), // Generate a temporary link for the file
        };
        onFileUploaded(data);
      }
    }
  };

  // Handle drag over
  const handleDragOver = (event) => {
    event.preventDefault(); // Prevent default behavior (e.g., opening as a link)
    event.stopPropagation(); // Stop the event from propagating up the DOM tree
  };

  // Handle drag leave
  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  // riya code end for Doc Drag and Drop

  useEffect(() => {
    dispatch(FetchAddTagsContact(tagValue));
  }, [tagValue]);

  useEffect(() => {
    dispatch(FetchManagersList());
    checkIfTempData();
    return () => {
      window.localStorage.removeItem("active-contact");
      setCanGoBack(false);
      dispatch({ type: "RESET_ADD_UPDATE_CONTACT" });
    };
  }, []);

  useEffect(() => {
    if (fetchAllManagers != null) {
      if (fetchAllManagers.status === 200) {
        setManagerList(fetchAllManagers?.data);
      }
    }
  }, [fetchAllManagers]);

  useEffect(() => {
    if (path.includes(`/contactlist/edit-contact/${id}`)) {
      if (docsContactListResponse.status === 200) {
        setContactDocsList(docsContactListResponse?.data?.data);
      }
    }
  }, [docsContactListResponse]);
  const [emailErr, setEmailErr] = useState(false);

  const [disableButton, setDisableButton] = useState(false);

  const handleContactAdd = () => {
    if (disableButton === true) return;
    if (isProcess) return;
    setRemoveaddbtn(true);
    setChangeComp("");

    if (fullName === "") {
      setErrorfull(true);
    } else {
      let year = dueDate.toISOString().split("-")[0];
      const date = dueDate.getDate();
      let month = dueDate.toISOString().split("-")[1];
      let datetime;
      if (hours.length === 1 && minutes.length === 1) {
        datetime = `${year}-${month}-${date}T0${hours}:0${minutes}:00.000Z`;
      } else if (hours.length === 1 && minutes.length === 2) {
        datetime = `${year}-${month}-${date}T0${hours}:${minutes}:00.000Z`;
      } else if (hours.length === 2 && minutes.length === 1) {
        datetime = `${year}-${month}-${date}T${hours}:0${minutes}:00.000Z`;
      } else {
        datetime = `${year}-${month}-${date}T${hours}:${minutes}:00.000Z`;
      }
      const fnames = fullName.split(" ");
      const firstName = fnames[0];
      fnames.shift();
      const lastName = fnames.join(" ") || "";
      const invalidEmails = [];
      const emailPattern = /^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/;

      emails.forEach((email) => {
        if (email.email && !emailPattern.test(email.email)) {
          invalidEmails.push(email.email);
        }
      });

      if (invalidEmails.length > 0) {
        // setErrorfull(true);
        setEmailError(true);
      } else {
        if (isUpdating) {
          setIsProcess(true);
          dispatch(
            UpdateContacts(
              userid,
              id,
              clientName,
              firstName,
              lastName,
              jobTitle,
              imageUrl,
              mainContactType,
              birthDate,
              marital,
              relationship,
              accountManagerId,
              notes,
              priorityId,
              emails,
              addresses,
              mobiles,
              tags,
            ),
          );
          setCanGoBack(true);
        } else {
          let newtag = [];
          tags?.forEach((elements) => {
            newtag.push({
              tagname: elements?.tagname,
            });
          });
          if (firstName !== "" || lastName !== "") {
            setIsProcess(true);
            dispatch(
              AddContact(
                userid,
                companyids,
                firstName,
                lastName,
                jobTitle,
                imageUrl,
                mainContactType,
                birthDate,
                marital,
                relationship,
                accountManagerId,
                notes,
                clientName ? clientName : "",
                priorityId,
                mobiles,
                emails,
                addresses,
                newtag,
              ),
            );
            setCanGoBack(true);
          }
          // if (invalidEmails.length > 0) {
          //   setErrorfull(true);
          //   setEmailError(true);
          // } else {

          // elsesetEmailError(false);
          // }
          else {
            history.goBack();
          }
          window.localStorage.removeItem("clientaddname");
        }
      }
    }
    window.localStorage.removeItem("_tmpCon");
    setDisableButton(true);
  };

  useEffect(() => {
    const processContactDocuments = () => {
      if (contactDocsList?.length > 0) {
        const reqArray = contactDocsList.map((element) => ({
          documentname: element?.documentname,
          documentextension: element?.documentextension,
          documentcontent: element?.documentcontent,
          link: element?.link,
          documentsize: element?.documentsize.toString(),
        }));

        dispatch(
          AddDocToUserContacts(
            addContactResponse?.data?.data?.contactid,
            userid,
            reqArray,
          ),
        );
      }
    };

    const sendContactMessage = async () => {
      if (!selectedGroupId) return;

      const newState = RichUtils.toggleInlineStyle(editorState, "BOLD");
      const textMessage = convertToRaw(newState.getCurrentContent());

      const messageId = uuidv4();
      const chatMessage = createChatMessage(textMessage, messageId);

      try {
        await connection.invoke(
          "SendMessage",
          `${currentCompanyId}-${selectedGroupId}`,
          chatMessage,
        );
      } catch (err) {
        console.error(err);
      }
    };

    const createChatMessage = (textMessage, messageId) => ({
      messageid: messageId,
      groupid: selectedGroupId,
      userid: currentUserId,
      messagetext: JSON.stringify(textMessage),
      attachments: "",
      type: "Group",
      senderimage: window.localStorage.getItem("userimageurl"),
      senderfirstname: window.localStorage.getItem("firstname"),
      senderlastname: window.localStorage.getItem("lastname"),
      contactid: addContactResponse?.data?.data?.contactid ?? "",
    });

    const handleRedirects = () => {
      if (passedState?.chatWidgetContact && connection) {
        sendContactMessage();
        history.push("/chat");
      } else if (localStorage.getItem("projectOnTheFly")) {
        history.push(`/addProject`, "/project");
      } else if (
        (companysContact && contactID) ||
        localStorage.getItem("comapanyClientIDFrom3Dot")
      ) {
        history.push(
          `/add-company/${
            contactID || localStorage.getItem("comapanyClientIDFrom3Dot")
          }`,
        );
      } else if (companysContact) {
        history.push(`/company-list`);
      } else if (passedState?.from === "planboard_Screen") {
        // history.push(`/planboard`);
        history.goBack();
      } else {
        history.push("/contact-list");

        window.localStorage.removeItem("clientaddname");
        window.localStorage.removeItem("clientId2");
        window.localStorage.removeItem("_tmpCon");
      }
    };

    const mainFlow = async () => {
      if (addContactResponse?.status === 200) {
        setIsProcess(false);
        processContactDocuments();
        // history.push("/contact-list");
        dispatch({ type: ADD_CONTACTS, data: {} });

        setTimeout(handleRedirects, 1000);
      }
    };

    mainFlow();
  }, [addContactResponse, connection]);

  useEffect(() => {
    if (connection) {
      connection.start().then(() => {
        console.log("connected");
      });
    }
  }, [connection]);

  useEffect(() => {
    const newConnection = new HubConnectionBuilder()
      .withUrl(`${CHAT_API_URL}/chat`, {
        withCredentials: true,
        accessTokenFactory: () =>
          Promise.resolve(window.localStorage.getItem("token")),
      })
      .withAutomaticReconnect()
      .build();

    setConnection(newConnection);
  }, []);

  const saveTempState = () => {
    const currentState = {
      fullName,
      jobTitle,
      imageUrl,
      mainContactType,
      emails,
      mobiles,
      addresses,
      birthDate,
      marital,
      relationship,
      accountManagerId,
      jobname,
      completeTags,
      tags,
      notes,
      clientName,
      clientId,
    };
    window.localStorage.setItem("_tmpCon", JSON.stringify(currentState));
  };

  useEffect(() => {
    if (updateContactResponse.status === 200) {
      setIsProcess(false);
      setTimeout(() => {
        if (passedState?.chatWidgetContact) {
          history.push("/chat");
          return;
        }
        dispatch({ type: UPDATE_CONTACTS, data: {} });
        history.push("/contact-list");
        window.localStorage.removeItem("clientaddname");
        window.localStorage.removeItem("clientId2");
        window.localStorage.removeItem("_tmpCon");
      }, 1000);
    }
  }, [updateContactResponse]);

  useEffect(() => {
    if (passedState?.adminUser) {
      setFullName(
        `${passedState?.adminUser?.firstname} ${passedState?.adminUser?.lastname}`,
      );
      setEmails([
        {
          email: passedState?.adminUser?.email,
          type: "Professional Email",
        },
      ]);
    }
  }, [passedState?.adminUser]);

  useEffect(() => {
    if (deletedocResponsedata?.data?.status === true) {
      dispatch(FetchDocsContactById(id));
    }
  }, [deletedocResponsedata]);

  useEffect(() => {
    if (id) {
      dispatch(FetchContactById(id));
      dispatch(FetchDocsContactById(id));
      dispatch(fetchTaskByContactId(id));
      window.localStorage.setItem("active-contact", id);
      // checkIfTempData();
    }
  }, [id]);

  const checkIfTempData = () => {
    if (localStorage.getItem("_tmpConRemoval")) {
      const tmpData = window.localStorage.getItem("_tmpCon");
      if (tmpData) {
        const jsonData = JSON.parse(tmpData);
        setFullName(jsonData.fullName);
        setJobTitle(jsonData.jobTitle);
        setImageUrl(jsonData.imageUrl);
        setMainContactType(jsonData.mainContactType);

        setEmails(jsonData.emails);
        setMobiles(jsonData.mobiles);
        setAddresses(jsonData.addresses);
        setBirthDate(jsonData.birthDate ? new Date(jsonData.birthDate) : null);
        setMarital(jsonData.marital);
        setRelationship(jsonData.relationship);
        setAccountManagerId(jsonData.accountManagerId);
        setJobname(jsonData.jobname);
        setCompleteTags(jsonData.completeTags);
        setTags(jsonData.tags);
        setNotes(jsonData.notes);
        // window.localStorage.removeItem("_tmpCon");
      }
    }
    localStorage.removeItem("_tmpConRemoval");
  };

  useEffect(() => {
    if (path.includes(`/contactlist/edit-contact/${id}`)) {
      if (singleContactResponse && singleContactResponse.status === 200) {
        setSingleContact(singleContactResponse?.data?.data);
        const contactObject = singleContactResponse?.data?.data[0];
        const { firstname, lastname } = contactObject;
        setFullName(`${firstname} ${lastname}`);
        setMarital(contactObject.maritalStatus);

        if (
          contactObject != null &&
          contactObject.contactaddress != null &&
          contactObject.contactaddress.length > 0
        )
          setAddresses(contactObject.contactaddress);

        if (
          contactObject != null &&
          contactObject.contactphonenumber != null &&
          contactObject.contactphonenumber.length > 0
        )
          setMobiles(contactObject.contactphonenumber);

        setMainContactType(contactObject.contacttype);
        // setContactType(contactObject.contacttype);
        setCompleteTags(contactObject.contacttag);
        setBirthDate(
          contactObject.dateofbirth ? new Date(contactObject.dateofbirth) : "",
        );
        setJobTitle(contactObject.jobtitle);
        setNotes(contactObject.notes);
        setImageUrl(contactObject.photo);
        setRelationship(contactObject.relationship);
        setPriority(contactObject.priorityname);
        setPriorityId(contactObject.priorityid);

        if (
          contactObject != null &&
          contactObject.contactemail != null &&
          contactObject.contactemail.length > 0
        )
          setEmails(contactObject.contactemail);

        setAccountManagerId(contactObject.accountmanager);
        setJobname(contactObject.accountmanagername);
        setTags(contactObject.contacttag);
        setClientName(
          window.localStorage.getItem("clientaddname") ||
            contactObject?.contactclients[0]?.clientname ||
            contactObject?.contactclients[0]?.clientname,
        );
        setClientId(
          window.localStorage.getItem("clientId2") ||
            contactObject?.contactclients[0]?.clientid ||
            contactObject?.contactclients[0]?.clientid,
        );
        setIsUpdating(true);
        checkIfTempData();
      }
    }
  }, [id, path, singleContactResponse]);
  useEffect(() => {
    fetchScreenTranslations("Add-Contact").then((res) => {
      setFetchTransAddContactList(res);
    });
  }, []);

  useEffect(() => {
    if (singleContact) {
      mapActiveActivityLogs();
    }
  }, [singleContact]);

  useEffect(() => {
    mapActiveActivityLogs();
  }, [selectedValue]);

  const mapActiveActivityLogs = () => {
    const currentActivity = selectedValue;
    if (
      singleContact &&
      singleContact[0] &&
      singleContact[0].activityLogs &&
      singleContact[0].activityLogs.length > 0
    ) {
      const activityLogs = singleContact[0].activityLogs;
      const filteredActivityLogs = [];

      const accessLevel = {
        CONTACTS: false,
        FILES: false,
        TASKS: false,
        EMAIL: false,
        EVENTS: false,
        TIME: false,
      };

      switch (currentActivity) {
        case "information":
          accessLevel.CONTACTS = true;
          break;
        case "docs":
          accessLevel.FILES = true;
          break;
        case "tasks":
          accessLevel.TASKS = true;
          break;
        case "events":
          accessLevel.EVENTS = true;
          break;
        case "emails":
          accessLevel.EMAIL = true;
          break;
        case "time":
          accessLevel.TIME = true;
          break;

        default:
          accessLevel.CONTACTS = true;
          accessLevel.FILES = true;
          accessLevel.TASKS = true;
          accessLevel.EMAIL = true;
          accessLevel.EVENTS = true;
          accessLevel.TIME = true;
          break;
      }

      activityLogs.forEach((log) => {
        switch (log.type) {
          case "Create":
            if (accessLevel.CONTACTS && log.tableName === "Contacts") {
              let newLog = {
                Icon: <img src={actinfo} alt="" />,
                message: `Contact Created by ${log.userFullName}`,
                time: getLocalFormatedTime(
                  log.dateTime,
                  "DD[/]MM[/]YYYY[.] HH:mm[H]",
                ),
              };
              filteredActivityLogs.unshift(newLog);

              if (log.newValues.Relationship) {
                let newLog = {
                  Icon: <img src={actinfo} alt="" />,
                  message: `Contact relationship set to ${log.newValues.Relationship.toUpperCase()} by ${
                    log.userFullName
                  }`,
                  time: getLocalFormatedTime(
                    log.dateTime,
                    "DD[/]MM[/]YYYY[.] HH:mm[H]",
                  ),
                };
                filteredActivityLogs.unshift(newLog);
              }
            }

            if (accessLevel.FILES && log.tableName === "Documents") {
              let newLog = {
                Icon: <img src={foldblue} alt="" />,
                message: `Document ${log.newValues.Documentname} Attached by ${log.userFullName}`,
                time: getLocalFormatedTime(
                  log.dateTime,
                  "DD[/]MM[/]YYYY[.] HH:mm[H]",
                ),
              };
              filteredActivityLogs.unshift(newLog);
            }
            if (accessLevel.TASKS && log.tableName === "Tasks") {
              let newLog = {
                Icon: <img src={taskIcon} alt="" />,
                message: `New Task assigned ${log.newValues.Taskname}`,
                time: getLocalFormatedTime(
                  log.dateTime,
                  "DD[/]MM[/]YYYY[.] HH:mm[H]",
                ),
              };
              filteredActivityLogs.unshift(newLog);
            }
            break;
          case "Update":
            if (
              accessLevel.CONTACTS &&
              log.tableName === "Contacts" &&
              isValidActivityLog(log)
            ) {
              let newLog = {
                Icon: <img src={actinfo} alt="" />,
                message: `Contact Updated by ${log.userFullName}`,
                time: getLocalFormatedTime(
                  log.dateTime,
                  "DD[/]MM[/]YYYY[.] HH:mm[H]",
                ),
              };
              filteredActivityLogs.unshift(newLog);

              if (log.newValues.Relationship) {
                let newLog = {
                  Icon: <img src={actinfo} alt="" />,
                  message: `Contact relationship set to ${log.newValues.Relationship.toUpperCase()} by ${
                    log.userFullName
                  }`,
                  time: getLocalFormatedTime(
                    log.dateTime,
                    "DD[/]MM[/]YYYY[.] HH:mm[H]",
                  ),
                };
                filteredActivityLogs.unshift(newLog);
              }
            }
            if (accessLevel.TASKS && log.tableName === "Tasks") {
              if (
                log.oldValues.IsDeleted == false &&
                log.newValues.IsDeleted == true
              ) {
                let newLog = {
                  Icon: <img src={taskIcon} alt="" />,
                  message: `Task Deleted by ${log.userFullName}`,
                  time: getLocalFormatedTime(
                    log.dateTime,
                    "DD[/]MM[/]YYYY[.] HH:mm[H]",
                  ),
                };
                filteredActivityLogs.unshift(newLog);
              } else {
                let newLog = {
                  Icon: <img src={taskIcon} alt="" />,
                  message: `Task Updated by ${log.userFullName}`,
                  time: getLocalFormatedTime(
                    log.dateTime,
                    "DD[/]MM[/]YYYY[.] HH:mm[H]",
                  ),
                };
                filteredActivityLogs.unshift(newLog);
              }
            }
            if (accessLevel.CONTACTS && log.tableName === "Clients") {
              if (log.newValues.Priceagreement) {
                let newLog = {
                  Icon: <img src={actinfo} alt="" />,
                  message: `${log.newValues.Priceagreement} Rate assigned`,
                  time: getLocalFormatedTime(
                    log.dateTime,
                    "DD[/]MM[/]YYYY[.] HH:mm[H]",
                  ),
                };
                filteredActivityLogs.unshift(newLog);
              }
            }
            break;
          case "Delete":
            if (accessLevel.TASKS && log.tableName === "Tasks") {
              let newLog = {
                Icon: <img src={taskIcon} alt="" />,
                message: `Task ${log.oldValues.Taskname} Deleted by ${log.userFullName}`,
                time: getLocalFormatedTime(
                  log.dateTime,
                  "DD[/]MM[/]YYYY[.] HH:mm[H]",
                ),
              };
              filteredActivityLogs.unshift(newLog);
            }
            if (accessLevel.FILES && log.tableName === "Documents") {
              let newLog = {
                Icon: <img src={foldblue} alt="" />,
                message: `Document ${log.oldValues.Documentname} Deleted by ${log.userFullName}`,
                time: getLocalFormatedTime(
                  log.dateTime,
                  "DD[/]MM[/]YYYY[.] HH:mm[H]",
                ),
              };
              filteredActivityLogs.unshift(newLog);
            }
            break;
          default:
            break;
        }
      });
      setActivityLogs(filteredActivityLogs);
    }
  };

  const isValidActivityLog = (log) => {
    if (log.affectedColumns) {
      if (
        log.affectedColumns.length === 1 &&
        log.affectedColumns[0] === "Updatedat"
      ) {
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    if (fetchAllTags != null) {
      if (fetchAllTags.status === 200) {
        setTagList(fetchAllTags?.data?.data);
      }
    }
  }, [fetchAllTags]);

  useEffect(() => {
    if (addTagResponse.status === 200) {
      setTagValue("");
      tags.push({
        tagname: addTagResponse?.data?.data?.tagname,
        tagid: addTagResponse?.data?.data?.tagid,
      });
      dispatch(FetchAddTagsContact());
    }
  }, [addTagResponse]);

  useEffect(() => {
    if (
      fullName &&
      jobTitle &&
      emails[0]?.email.length > 0 &&
      mobiles[0]?.phoneNumber.length > 0 &&
      clientVatNumber &&
      amount &&
      accountManagerId !== "Select Manager"
    ) {
      setDisableBtn(false);
    } else {
      setDisableBtn(true);
    }
  }, [fullName, clientVatNumber, amount, emails, mobiles, accountManagerId]);

  const DeleteTag = async (tagid) => {
    await dispatch(DeleteTags(tagid));
    await dispatch(FetchAddTagsContact(tagValue));
  };

  const maritailOptions = [
    { value: "-" },
    { value: "Single" },
    { value: "Married" },
    { value: "Divorced" },
    { value: "Widow" },
  ];

  const handelCancel = () => {
    history.goBack();
    // if (isUpdating === true) {
    //   if (changeComp !== "") {
    //     setPopups(true);
    //   } else {
    //     history.push("/contact-list");
    //     window.localStorage.removeItem("clientaddname");
    //     window.localStorage.removeItem("clientId2");
    //     window.localStorage.removeItem("_tmpCon");
    //   }
    // } else if (
    //   fullName != "" ||
    //   jobTitle != "" ||
    //   imageUrl != "" ||
    //   notes != "" ||
    //   tags != ""
    // ) {
    //   setPopups(true);
    //   window.localStorage.removeItem("clientaddname");
    // } else {
    //   if (changeComp !== "") {
    //     setPopups(true);
    //   } else {
    //     history.push("/contact-list");
    //     window.localStorage.removeItem("clientaddname");
    //     window.localStorage.removeItem("clientId2");
    //     window.localStorage.removeItem("_tmpCon");
    //     dispatch(RemoveDocsClientById());
    //   }
    // }
  };

  const refAccountManager = useRef();
  const handleAccountManagerMouseDown = (event) => {
    if (
      refAccountManager.current &&
      !refAccountManager.current.contains(event.target)
    ) {
      setShowAccountManagerDrop(false);
    }
  };
  useEffect(() => {
    if (showAccountManagerDrop) {
      window.addEventListener("mousedown", handleAccountManagerMouseDown);
    } else {
      window.removeEventListener("mousedown", handleAccountManagerMouseDown);
    }
    return () => {
      window.removeEventListener("mousedown", handleAccountManagerMouseDown);
    };
  }, [showAccountManagerDrop]);

  const refRelationshipManager = useRef();
  const handleRelationshipMouseDown = (event) => {
    if (
      refRelationshipManager.current &&
      !refRelationshipManager.current.contains(event.target)
    ) {
      setShowRelationShipDrop(false);
    }
  };
  useEffect(() => {
    if (showRelationShipDrop) {
      window.addEventListener("mousedown", handleRelationshipMouseDown);
    } else {
      window.removeEventListener("mousedown", handleRelationshipMouseDown);
    }
    return () => {
      window.removeEventListener("mousedown", handleRelationshipMouseDown);
    };
  }, [showRelationShipDrop]);

  const refPriority = useRef();
  const handlePriorityMouseDown = (event) => {
    if (refPriority.current && !refPriority.current.contains(event.target)) {
      setShowPriorityDrop(false);
    }
  };
  useEffect(() => {
    if (showPriorityDrop) {
      window.addEventListener("mousedown", handlePriorityMouseDown);
    } else {
      window.removeEventListener("mousedown", handlePriorityMouseDown);
    }
    return () => {
      window.removeEventListener("mousedown", handlePriorityMouseDown);
    };
  }, [showPriorityDrop]);

  const refMarital = useRef();
  const handleMaritalMouseDown = (event) => {
    if (refMarital.current && !refMarital.current.contains(event.target)) {
      setShowMaritalStatusDrop(false);
    }
  };
  useEffect(() => {
    if (showMaritalStatusDrop) {
      window.addEventListener("mousedown", handleMaritalMouseDown);
    } else {
      window.removeEventListener("mousedown", handleMaritalMouseDown);
    }
    return () => {
      window.removeEventListener("mousedown", handleMaritalMouseDown);
    };
  }, [showMaritalStatusDrop]);

  const companyDropDownRef = useRef();
  const handleCompanyDropDown = (event) => {
    if (
      companyDropDownRef.current &&
      !companyDropDownRef.current.contains(event.target)
    ) {
      setOpenCompanyDropdown(false);
      setClientName("");
    }
  };
  useEffect(() => {
    if (openCompanyDropdown) {
      window.addEventListener("mousedown", handleCompanyDropDown);
    } else {
      window.removeEventListener("mousedown", handleCompanyDropDown);
    }
    return () => {
      window.removeEventListener("mousedown", handleCompanyDropDown);
    };
  }, [openCompanyDropdown]);

  const BpIcon = style("span")(() => ({
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "dark" === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "dark" === "dark" ? "#FFFFFF" : "#f5f8fa",
    backgroundImage:
      "dark" === "dark"
        ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "dark" === "dark" ? "#FFFFFF" : "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        "dark" === "dark" ? "rgba(57,75,89,.5)" : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = style(BpIcon)({
    backgroundColor: "#00246A",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 0,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  });
  const fetchComments = async (taskId) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchComments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        relatedtoid: taskId,
        type: "task",
      },
    }).then((response) => {
      setComments(response.data);
    });
  };

  const handleAddComments = () => {
    dispatch(AddComments(userid, taskid, val, "task", imgUrl, taggedUser));
    setTimeout(() => {
      fetchComments(taskid);
    }, 1000);
    setTaggedUser([]);
    setMessage("");
    setVal("");
    setImgUrl("");
  };

  useEffect(() => {
    if (taskid) {
      fetchComments(taskid);
    }
  }, [taskid]);

  const handleFileChange22 = (e) => {
    const target = e.target.files[0];
    let formData = new FormData();
    formData.append("file", target);

    axios
      .put(`${API_URL}/api/Files/UploadToS3`, formData)
      .then(function (response) {
        if (response !== null) {
          setImgUrl(response.data[0]);
        } else {
        }
      })
      .catch(function () {});
  };

  const handleFileChange = (data) => {
    setImgUrl(data.link);
    // setAttachMessage(`${data.name} File is Attached in comment box`);
  };

  const onButtonClick = () => {
    // inputFile.current.click();
  };

  // useEffect(() => {
  //   if (TaskId) {
  //     setReRenderAPI(true);
  //     // setShowModal(true);
  //     setTaskid(TaskId);
  //     setModalFunctionNoty("Notification");
  //   }
  //   setTimeout(() => {
  //     window.localStorage.removeItem("taskid");
  //   }, 5000);

  //   return () => {
  //     window.localStorage.removeItem("taskid");
  //   };
  // }, []);
  const initialRender5 = React.useRef(true);
  React.useEffect(() => {
    if (!initialRender5.current) {
      if (comments != null) {
        if (comments.status == true) {
          setMinComments([]);
          var date = new Date(comments.data[0]?.timestamp)
            .toString()
            .split(" ");
          setcurrentDate(date);
          setShow(comments.data);
          setLength(comments.data.length);
          setFirstNameComm(comments.data[0]?.firstname);
          setLastNameComm(comments.data[0]?.lastname);
          for (var i = 0; i < 5; i++) {
            minComments.push(comments.data[i]);
          }
          setMaxComments(minComments.filter((item) => item != undefined));
        } else {
        }
      }
    } else {
      initialRender5.current = false;
    }
  }, [comments]);

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      fontWeight: 400,
      color: "#333333",
      fontSize: "14px",
      background: "#F1F1F1 0% 0% no-repeat padding-box",
      boxShadow: "0px 3px 6px #00000029",
      opacity: 1,
    },
  }));
  const handleDownloadContact = (event, documentid, documentname) => {
    axios({
      method: "post",
      url: `${API_URL}/api/Files/DownloadToS3?documentid=` + documentid,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const document = window.document || {};
      const link = document.createElement("a");
      link.href = url;
      link.download = documentname;
      document.body.appendChild(link);
      link.click();
    });
  };

  const getNameAbbrivation = useMemo(() => {
    if (fullName) {
      const arr = fullName.split(" ").filter((x) => Boolean(x));
      arr.forEach((x) => {
        return x.trim();
      });
      if (arr.length > 0) {
        if (arr.length === 1) {
          return arr[0].slice(0, 2)?.toUpperCase();
        } else if (arr.length > 1) {
          return `${arr[0].slice(0, 1)?.toUpperCase()}${arr[1]
            .slice(0, 1)
            ?.toUpperCase()}`;
        }
      }
    }
  }, [fullName]);

  const handleOpenUpdateTaskPopup = (taskid) => {
    setModalFunction("update");
    setTaskid(taskid);
    setShowModal(true);
    setReRenderAPI(true);
  };

  const [taskIdforDelete, setTaskIdforDelete] = useState("");

  const handleDelete = (e) => {
    dispatch(deleteTask(taskIdforDelete));
    setShowPopup(false);
  };
  useEffect(() => {
    if (linkOrAddClientResponse.status === 200) {
      window.localStorage.setItem(
        "clientaddname",
        linkOrAddClientResponse?.data?.data?.clientname,
      );
      window.localStorage.setItem(
        "clientId2",
        linkOrAddClientResponse?.data?.data?.clientid,
      );
      setClientId(linkOrAddClientResponse?.data?.data?.clientid);
    }
  }, [linkOrAddClientResponse]);

  const addCompanyFuc = (event) => {
    setHideDropdown(true);
    if (
      !companyDropDownRef.current ||
      !companyDropDownRef.current.contains(event.target)
    ) {
      if (clientName) {
        localStorage.setItem("_ce", true);
        saveTempState();
        window.localStorage.setItem("clientaddname", clientName);
        window.localStorage.setItem("clientId2", clientId);
        history.push({
          pathname: clientId ? `/add-company/${clientId}` : "/add-company",
        });
      } else {
        setOpenCompanyDropdown(true);
        dispatch(FetchSearchClients(""));
      }
    }
  };
  useEffect(() => {
    if (searchClientResponse.status === 200) {
      if (searchClientResponse != null) {
        setSearchingClients(searchClientResponse?.data?.data);
        setHideDropdown(true);
        if (searchClientResponse?.data?.data?.length === 0) {
          setHideDropdown(false);
        }
      }
    }
  }, [searchClientResponse]);

  const handleEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      dispatch(
        AddCompanyContact(
          userid,
          clientName,
          "", // Empty string as the default value for street
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
        ),
      );
      setOpenCompanyDropdown(false);
    }
  };

  useEffect(() => {
    if (openCompanyDropdown) {
      // Focus on the input element when the dropdown opens
      inputRef.current.focus();
    }
  }, [openCompanyDropdown]);

  const [val, setVal] = useState("");
  const [statusList, setStatusList] = useState([]);
  const [showNewTaskSystem, setShowNewTaskSystem] = useState(false);

  useEffect(() => {
    if (companyId === "28830f30-b321-4662-a576-f23451677742")
      return setShowNewTaskSystem(false);
    if (packageID === process.env.REACT_APP_IS_PREMIUM) {
      setShowNewTaskSystem(true);
    }
  }, [packageID, companyId]);

  useEffect(() => {
    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/Stage/GetTaskStatusDropdownList`,
        method: "get",
        state: "getTaskStatusListRes",
        data: {},
      }),
    );
  }, []);

  useEffect(() => {
    if (getTaskStatusListRes?.status === true) {
      setStatusList(getTaskStatusListRes?.data);
    }
  }, [getTaskStatusListRes]);

  const [isBasicMember, setIsBasicMember] = useState(false);
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      const isBasicPlan = getAppSideNavOptions.every(
        (x) =>
          x.packageName.toUpperCase() == "BASIC" &&
          x.packageId == process.env.REACT_APP_IS_BASIC,
      );
      setIsBasicMember(isBasicPlan);

      const isBuildingBlockVal = getAppSideNavOptions.every(
        (x) => x.packageId == process.env.REACT_APP_IS_PREMIUM,
      );
      setIsBuildingBlock(isBuildingBlockVal);
    }
  }, [getAppSideNavOptions]);

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      refActivityTimelineDD.current &&
      !refActivityTimelineDD.current.contains(event.target)
    ) {
      setFilterDrop(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const [pinCodeForAdress, setPinCodeForAdress] = useState("");

  const getAddressParts = (parsed = {}) => ({
    street: parsed.streetWithNumber || parsed.street || "",
    city: parsed.city || "",
    state: parsed.state || "",
    pinCode: parsed.pinCode || parsed.postalCode || "",
    country: parsed.country || "",
  });

  // postal Code start
  const handleAddressSelect = async (address, type) => {
    try {
      const parsed = await parseGooglePlace(address);
      setPinCodeForAdress(parsed.formattedAddress);
      setAddresses(
        addresses.map((adr) =>
          adr.type === type
            ? {
                ...adr,
                address: parsed.formattedAddress,
                ...getAddressParts(parsed),
              }
            : adr,
        ),
      );
    } catch (err) {
      console.log("Error while fetching address meta ", err);
    } finally {
      console.log("Address API Call Completed");
    }
  };

  // postal Code end

  const [companysContact, setCompanysContact] = useState(
    passedState?.historyCompanysContact,
  );

  // companys contacts State start
  const [companysContsEmail, setCompanysContsEmail] = useState("");
  const [companysContsMobile, setCompanysContsMobile] = useState("");
  const [companysContsOfficeTelNo, setCompanysContsOfficeTelNo] = useState("");
  const [companysContsBirthDate, setCompanysContsBirthDate] = useState("");
  const [companysContsRelations, setCompanysContsRelations] = useState("");
  const [companysContsNotes, setCompanysContsNotes] = useState("");
  // companys contacts State end

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);

  return (
    <>
      <Header
        leftComponent={
          <div className="flex-wrap gap-4 d-flex align-items-baseline">
            <div
              className="projectText"
              onClick={() => {
                history.push("/contact-list");
              }}
            >
              {/* Contact */}
              {t("Contacts")}
            </div>
            <div
              className="pt-2 d-flex pe-3 d-none"
              style={{ background: "#FFFFFF" }}
            >
              <p className="pt-1 ps-4 projectText2">
                {/* Project */}
                {/* {FetchTranslationList[55]?.translation} */}
              </p>
              {/* <p className="pt-3 projectID ps-5"> ID &nbsp;{projectIdCode} </p> */}
            </div>
          </div>
        }
      />

      {showPopup && (
        <TasDelete
          animation={true}
          handleDelete={handleDelete}
          show={showPopup}
          onHide={() => setShowPopup(false)}
        />
      )}
      <RouteLeavingGuard
        when={changeComp !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          // This case it blocks the navigation when:
          // 1. the login form is dirty, and
          // 2. the user is going to 'sign-up' scene.
          //    (Just an example, in real case you might
          //     need to block all location regarding this case)
          if (changeComp !== "") {
            if (
              ![
                "/add-contact",
                `/contactlist/edit-contact/${id}`,
                "/NewInvoice",
                "/add-purchasing-order",
                "/chat",
              ].includes(location.pathname)
            ) {
              if (location.pathname === "/contact-list" && !canGoBack) {
                return true;
              } else if (location.pathname === "/contact-list" && canGoBack)
                return false;
              return true;
            }
          }
          return false;
        }}
      />

      {reRenderAPI && (
        <AddTaskModal
          val={val}
          setVal={setVal}
          showModal={showModal}
          defaultContactId={id}
          modalFunctionNoty={modalFunctionNoty}
          taskid={taskid}
          setTaskid={setTaskid}
          popups={popups}
          setPopups={setPopups}
          statusList={statusList}
          showNewTaskSystem={showNewTaskSystem}
          isBasicMember={isBasicMember}
          isBuildingBlock={isBuildingBlock}
          setShowModal={(show, reload) => {
            setShowModal(false);
            setActiveHeading("3");
            window.localStorage.removeItem("taskid");
            dispatch(EmptyProductPart());
            if (reload) {
              dispatch(fetchTaskByContactId(id));
            }
          }}
          setComments={setComments}
          modalFunction={modalFunction}
          setModalFunction={setModalFunction}
          setEnableComm={setEnableComm}
          setShowcmnt={setShowcmnt}
          enablecomm={enablecomm}
          showcmnt={showcmnt}
          setMessage={setMessage}
          message={message}
          onButtonClick={onButtonClick}
          handleFileChange={handleFileChange}
          handleAddComments={handleAddComments}
          setTaggedUser={setTaggedUser}
          taggedUser={taggedUser}
          maxComments={maxComments}
          show={show}
          length={length}
          setLength={setLength}
          setShow={setShow}
          imgUrl={imgUrl}
          setImgUrl={setImgUrl}
          setMaxComments={setMaxComments}
          from={from}
          searchText={searchText}
        />
      )}
      <section className="main-add-contact">
        <div className="ps-4 pe-4">
          <Row>
            <Col xl={8} lg={7} md={6} sm={12}>
              {companysContact && (
                <p
                  className="fw-bold mt-2 mb-0 p-2"
                  style={{
                    fontSize: "16px",
                    color: "#707070",
                    fontWeight: "700",
                    background: "#FFFFFF",
                  }}
                >
                  {/* {fetchTransAddContactList[0]?.translation} */}
                  Company &nbsp; &nbsp;
                  <span
                    style={{
                      fontSize: "16px",
                      color: "#333333",
                      opacity: "0.6",
                      fontWeight: "600",
                    }}
                  >
                    {/* {`${passedState?.historyCompanyName} ❮ Linked contct list`} */}
                    {`${passedState?.historyCompanyName} `}
                    &nbsp; &nbsp; ❮ &nbsp; &nbsp;
                    {` Linked contact list`}
                  </span>
                </p>
              )}
            </Col>
            <Col
              xl={4}
              lg={5}
              md={6}
              sm={12}
              className="add-col-item upperADD_CancelBtnShoeHide"
            >
              <div
                className="d-flex cancel_cont_btn"
                onClick={() => {
                  handelCancel();
                }}
                style={{ borderRadius: "12px" }}
              >
                <p className="fw-bold mb-0" style={{ color: "#5b5b5b" }}>
                  {/* cancel */}
                  {t("Cancel")}
                </p>
              </div>
              {removeaddbtn ? (
                <div
                  className="d-flex add-buttons ms-4"
                  style={{ borderRadius: "12px" }}
                  onClick={handleContactAdd}
                >
                  <p className="fw-bold mb-0">
                    {isUpdating
                      ? // ? "Confirm"
                        t("Confirm")
                      : t("Add")}
                  </p>
                </div>
              ) : (
                <div
                  className="d-flex add-buttons ms-4"
                  style={{ borderRadius: "12px" }}
                  onClick={handleContactAdd}
                >
                  <p className="fw-bold mb-0">
                    {isUpdating
                      ? // ? "Confirm"
                        t("Confirm")
                      : t("Add")}
                  </p>
                </div>
              )}
            </Col>
          </Row>
        </div>
        <section className="add-contact-info-container ps-4 pe-4">
          <div
            className={
              roleAccess === process.env.REACT_APP_IS_VIEWER
                ? "pointerEvent column-1-info"
                : "column-1-info"
            }
          >
            <div className="contact-type" style={{ height: "40px" }}>
              <div className="contact-type-grid">
                <span
                  className={
                    mainContactType === "Client" ? "active-contact" : "contact"
                  }
                  style={
                    mainContactType === "Client"
                      ? {
                          backgroundColor:
                            companyId === "28830f30-b321-4662-a576-f23451677733"
                              ? "#C6BE00"
                              : companyId ===
                                  "28830f30-b321-4662-a576-f23451677744"
                                ? "#9BE6E4"
                                : companyId ===
                                    "28830f30-b321-4662-a576-f23451677755"
                                  ? "#D8BD90"
                                  : " ",
                          color: "white",
                        }
                      : {}
                  }
                  onClick={() => {
                    if (isNotRole(ROLES.VIEWER)) {
                      // setContactType("Client");
                      setMainContactType("Client");
                      setChangeComp("Client");
                    }
                  }}
                >
                  {t("Client")}
                </span>
                <span
                  style={
                    mainContactType === "Other"
                      ? {
                          backgroundColor:
                            companyId === "28830f30-b321-4662-a576-f23451677733"
                              ? "#C6BE00"
                              : companyId ===
                                  "28830f30-b321-4662-a576-f23451677744"
                                ? "#9BE6E4"
                                : companyId ===
                                    "28830f30-b321-4662-a576-f23451677755"
                                  ? "#D8BD90"
                                  : " ",
                          // backgroundColor: `${primaryColor}`,
                          color: "white",
                        }
                      : {}
                  }
                  onClick={() => {
                    if (isNotRole(ROLES.VIEWER)) {
                      // setContactType("Other");
                      setMainContactType("Other");
                      setChangeComp("other");
                    }
                  }}
                  className={
                    mainContactType === "Other" ? "active-contact" : "contact"
                  }
                >
                  {t("Other")}
                </span>
              </div>
            </div>
            <div className="d-flex flex-column align-items-center justify-content-center">
              <div
                className="profile-image-details image-styles"
                onDragOver={(e) => {
                  e.preventDefault();
                }}
                onDragLeave={(e) => {
                  e.preventDefault();
                }}
                onDrop={(e) => {
                  e.preventDefault();

                  const droppedFile = Array.from(e.dataTransfer.files);
                  if (droppedFile) {
                    profileUpload(droppedFile[0]);
                  }
                }}
              >
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  ref={hiddenFileInput}
                  onChange={(event) => {
                    const fileUploaded = event.target.files[0];
                    if (fileUploaded) {
                      const image = URL.createObjectURL(fileUploaded);
                      setChangeComp(image);
                      setImageUrl(image);
                      profileUpload(fileUploaded);
                    } else {
                      return;
                    }
                  }}
                />
                {imageUrl && isUpdating ? (
                  <div
                    id="profile-image"
                    className="profile-image"
                    style={{
                      border: `7px ${primaryColor} solid`,
                      marginTop: "6rem",
                    }}
                  >
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "100%",
                        objectFit: "cover",
                      }}
                      src={imageUrl}
                      alt=""
                    />
                  </div>
                ) : imageUrl === "" && isUpdating ? (
                  <div
                    id="profile-image"
                    className="profile-image"
                    style={{
                      // border: "1px #00256E dashed",
                      marginTop: "6rem",
                    }}
                  >
                    <div
                      style={{
                        borderRadius: "50%",
                        backgroundColor: "#95A7C6",
                        fontSize: "48px",
                        fontWeight: 800,
                        height: "100%",
                        color: "#FFFFFF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {getNameAbbrivation}
                    </div>
                  </div>
                ) : imageUrl && !isUpdating ? (
                  <div
                    id="profile-image"
                    className="profile-image"
                    style={{
                      border: `7px ${primaryColor} solid`,
                      marginTop: "6rem",
                    }}
                  >
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "100%",
                        objectFit: "cover",
                      }}
                      src={imageUrl}
                      alt=""
                    />
                  </div>
                ) : (
                  <div>
                    <div
                      id="profile-image"
                      className="profile-image"
                      style={{
                        marginTop: "35%",
                        cursor: "pointer",
                        border: "1px #00256E dashed",
                        marginTop: "6rem",
                      }}
                    >
                      <img
                        src={Addiocn}
                        alt="add"
                        style={{
                          marginTop: "40px",
                          fontSize: "clamp(13px,1.1vw,2vw)",
                        }}
                        onClick={handleClick}
                      />
                      <br />
                      <p
                        className="company"
                        id="company"
                        style={{ color: "#00246A", opacity: "1" }}
                        onClick={handleClick}
                      >
                        {/* Add or drag
                        <br />a photo */}
                        {t("Add or drag a photo").slice(0, 6)}
                        <br />
                        {t("Add or drag a photo").slice(6)}
                      </p>
                    </div>
                  </div>
                )}

                {imageUrl && (
                  <>
                    <div className="mt-3">
                      <span
                        className="change"
                        style={{
                          color: "#A5A5A5",
                          fontSize: "clamp(11px, 0.729vw, 1.2vw)",
                          cursor: "pointer",
                        }}
                        onClick={handleClick}
                      >
                        {"Change"}
                      </span>
                      <span className="mt-3">
                        <img
                          src={Binclr}
                          alt="bin"
                          className="change"
                          style={{
                            fontSize: "1rem",
                            marginLeft: "0.2rem",
                            width: "1.098vw",
                            height: "1.245vw",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (imageUrl) {
                              setDeleteModalShow(true);
                            }
                          }}
                        />
                      </span>
                    </div>
                  </>
                )}
                {isUpdating && !imageUrl && (
                  <>
                    <div className="mt-3">
                      <span
                        className="change"
                        style={{
                          cursor: "pointer",
                          color: "#A5A5A5",
                          fontSize: "clamp(11px, 0.729vw, 1.2vw)",
                        }}
                        onClick={handleClick}
                      >
                        Add Picture
                      </span>
                    </div>
                  </>
                )}
              </div>
              <div className="d-flex">
                <input
                  type="text"
                  // className="input-name-style"
                  className={
                    errorfull
                      ? "input-name-style2 mt-5"
                      : roleAccess === process.env.REACT_APP_IS_VIEWER
                        ? "pointerEvent input-name-style mt-5"
                        : "input-name-style mt-5"
                  }
                  value={fullName}
                  onChange={(e) => {
                    setFullName(
                      e.target.value.charAt(0).toUpperCase() +
                        e.target.value.slice(1),
                    );
                    setChangeComp(e.target.value);
                    setErrorfull(false);
                  }}
                  placeholder={t("Add Name and Surname")}
                />
                <span className="mandatory-sign d-flex align-items-end">*</span>
              </div>
              <input
                type="text"
                // className="input-job-style"
                className={
                  roleAccess === process.env.REACT_APP_IS_VIEWER
                    ? "pointerEvent input-job-style"
                    : "input-job-style"
                }
                value={jobTitle}
                onChange={(e) => {
                  setJobTitle(e.target.value);
                  setChangeComp(e.target.value);
                }}
                placeholder={t("Add a Job title")}
              />
              {/* {contactType === "prospect" && ( */}
              <div
                style={{
                  textDecoration: "none",
                  cursor: "pointer",
                  color: "#A5A5A5",
                  opacity: "1",
                  position: "relative",
                  width: "fit-content",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
                className="input-job-style input-company-style"
                onClick={(event) => addCompanyFuc(event)}
              >
                {/* Add a Company */}
                <span
                  style={{
                    display: openCompanyDropdown ? "none" : "",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    width: "150px",
                  }}
                >
                  {clientName ? clientName : t("Add a Company")}
                </span>
                {openCompanyDropdown && (
                  <div
                    className="company-drop-down "
                    ref={companyDropDownRef}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: "-80px",
                    }}
                  >
                    <div style={{ marginBottom: hideDropdown ? "10px" : "0" }}>
                      <input
                        type="text"
                        className="company-name-input"
                        onChange={(e) => {
                          setClientName(e.target.value);
                          dispatch(FetchSearchClients(e.target.value));
                        }}
                        ref={inputRef}
                        onKeyDown={handleEnterKeyPress}
                      />
                      {hideDropdown && (
                        <div className="my-custom-scrollbars">
                          {searchingClients.map((project, index) => {
                            const clientNameLower = (
                              project.clientname || ""
                            ).toLowerCase();
                            const searchLower = (
                              clientName || ""
                            ).toLowerCase();
                            const startIndex =
                              clientNameLower.indexOf(searchLower);
                            return (
                              <div
                                onClick={() => {
                                  setOpenCompanyDropdown(false);
                                  setClientName(project.clientname);
                                  setClientId(project.clientid);
                                }}
                                className="mb-1"
                                key={`index-${project.clientid}-${index}`}
                                style={{
                                  display: "flex",
                                  color: "#333333",
                                  opacity: "1",
                                  fontSize: "clamp(14px, 1vw, 1.2vw)",
                                }}
                              >
                                {startIndex !== -1 ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <div
                                      style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        width: "154px",
                                        display: "block",
                                        textAlign: "start",
                                      }}
                                    >
                                      <span>
                                        {project.clientname.substring(
                                          0,
                                          startIndex,
                                        )}
                                      </span>
                                      <strong>
                                        {project.clientname.substring(
                                          startIndex,
                                          startIndex + searchLower.length,
                                        )}
                                      </strong>
                                      {project.clientname.substring(
                                        startIndex + searchLower.length,
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  project.clientname
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="column-1-options">
                <div
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "d-none"
                      : path === "/add-contact"
                        ? "d-flex justify-content-end"
                        : ""
                  }
                >
                  <DocumentUploaderWithProgress
                    maxSizeInMb={100}
                    onUploaded={onFileUploaded}
                    filefilter={
                      ".doc,.pdf,.xls,.xlsx,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    }
                  >
                    <span
                      style={{
                        position: "relative",
                        fontWeight: "600",
                        cursor: "pointer",
                        color: "#333333",
                      }}
                      className="responsive-font-14"
                    >
                      <img
                        alt="doc"
                        src={docicons}
                        style={{
                          width: "22px",
                          height: "20px",
                          marginRight: "0.25rem",
                        }}
                      />
                      {t("Doc ")}
                    </span>
                  </DocumentUploaderWithProgress>
                </div>
                <div
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "d-none"
                      : ""
                  }
                >
                  <span
                    style={{
                      position: "relative",
                      // fontSize: "14px",
                      fontWeight: "600",
                      cursor: isUpdating ? "pointer" : "not-allowed",
                      color: isUpdating ? "#333333" : "#999999",
                    }}
                    // onClick={() => {
                    //   setShowTaskColumn(!showTaskColumn);
                    // }}
                    // className="responsive-font-14"
                    className={
                      path === "/add-contact" ? "d-none" : "responsive-font-14"
                    }
                    onClick={() => {
                      if (isUpdating) {
                        setModalFunction("add");
                        setShowModal(true);
                        setReRenderAPI(true);
                      }
                    }}
                  >
                    <img
                      src={Taskicon}
                      alt="taskicon"
                      style={{
                        width: "22px",
                        height: "24px",
                        marginRight: "0.25rem",
                      }}
                    />
                    {/* <AiFillPlusCircle
                      style={{
                        position: "absolute",
                        top: "10px",
                        left: "8px",
                        color: `${primaryColor}`,
                        background: "white",
                        borderRadius: "50%",
                      }}
                    /> */}
                    {t("Task")}
                  </span>
                </div>
                {packageID === process.env.REACT_APP_IS_PREMIUM && (
                  <div>
                    <span
                      style={{
                        position: "relative",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                      className="responsive-font-14"
                    >
                      <img
                        alt="img2email"
                        src={image2}
                        style={{
                          minWidth: "24px",
                          minHeight: "24px",
                          width: "1.2vw",
                          height: "1.2vw",
                          marginRight: "0.25rem",
                        }}
                      />
                      {/* <AiFillPlusCircle
                      style={{
                        position: "absolute",
                        top: "8px",
                        left: "12px",
                        color: `${primaryColor}`,
                        background: "white",
                        borderRadius: "50%",
                      }}
                    /> */}
                      {/* Email */}
                      {t("Email")}
                    </span>
                  </div>
                )}
                {/* <div>
                  <span
                    style={{
                      position: "relative",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                    className="responsive-font-14"
                  >
                    <img
                      src={image3}
                      style={{
                        minWidth: "24px",
                        minHeight: "24px",
                        width: "1.2vw",
                        height: "1.2vw",
                        marginRight: "0.25rem",
                      }}
                    />
                    <AiFillPlusCircle
                      style={{
                        position: "absolute",
                        top: "8px",
                        left: "12px",
                        color: `${primaryColor}`,
                        background: "white",
                        borderRadius: "50%",
                      }}
                    />
                    Event
                  </span>
                </div> */}
              </div>
            </div>
          </div>
          {!docAdded ? (
            <>
              {!showTaskColumn ? (
                <>
                  <div className="column-2-info">
                    <div className="information-tabs">
                      <div
                        style={
                          activeHeading === "1"
                            ? { color: `${primaryColor}` }
                            : {}
                        }
                        className={
                          activeHeading === "1"
                            ? "tab-headings active-tab-heading responsive-font-14"
                            : "tab-headings responsive-font-14"
                        }
                        onClick={() => setActiveHeading("1")}
                      >
                        {t("Information")}
                        {activeHeading === "1" && (
                          <div
                            className="tab-underline"
                            style={
                              activeHeading === "1"
                                ? { backgroundColor: `${primaryColor}` }
                                : {}
                            }
                          ></div>
                        )}
                      </div>
                      <div
                        style={
                          activeHeading === "2"
                            ? { color: `${primaryColor}` }
                            : {}
                        }
                        className={
                          activeHeading === "2"
                            ? "tab-headings active-tab-heading responsive-font-14"
                            : "tab-headings responsive-font-14"
                        }
                        onClick={() => setActiveHeading("2")}
                      >
                        {t("Docs")}
                        {activeHeading === "2" && (
                          <div
                            className="tab-underline"
                            style={
                              activeHeading === "2"
                                ? { backgroundColor: `${primaryColor}` }
                                : {}
                            }
                          ></div>
                        )}
                      </div>
                      <div
                        style={
                          activeHeading === "3"
                            ? { color: `${primaryColor}` }
                            : {}
                        }
                        className={
                          activeHeading === "3"
                            ? "tab-headings active-tab-heading responsive-font-14"
                            : path === "/add-contact"
                              ? "d-none"
                              : "tab-headings responsive-font-14"
                        }
                        onClick={() => setActiveHeading("3")}
                      >
                        {t("Task")}
                        {activeHeading === "3" && (
                          <div
                            className="tab-underline"
                            style={
                              activeHeading === "3"
                                ? { backgroundColor: `${primaryColor}` }
                                : {}
                            }
                          ></div>
                        )}
                      </div>
                      {packageID === process.env.REACT_APP_IS_PREMIUM && (
                        <>
                          {roleAccess !== ROLES.VIEWER && (
                            <div
                              style={
                                activeHeading === "4"
                                  ? { color: `${primaryColor}` }
                                  : { visibility: "" }
                              }
                              className={
                                activeHeading === "4"
                                  ? "tab-headings active-tab-heading responsive-font-14"
                                  : "tab-headings responsive-font-14"
                              }
                              onClick={() => setActiveHeading("4")}
                            >
                              {/* Emails */}
                              {t("Emails")}
                              {activeHeading === "4" && (
                                <div
                                  className="tab-underline"
                                  style={
                                    activeHeading === "4"
                                      ? { backgroundColor: `${primaryColor}` }
                                      : {}
                                  }
                                ></div>
                              )}
                            </div>
                          )}
                        </>
                      )}
                      <div
                        style={
                          activeHeading === "5"
                            ? { color: `${primaryColor}` }
                            : { visibility: "hidden" }
                        }
                        className={
                          activeHeading === "5"
                            ? "tab-headings active-tab-heading responsive-font-14"
                            : "tab-headings responsive-font-14"
                        }
                        onClick={() => setActiveHeading("5")}
                      >
                        Events
                        {activeHeading === "5" && (
                          <div
                            className="tab-underline"
                            style={
                              activeHeading === "5"
                                ? { backgroundColor: `${primaryColor}` }
                                : {}
                            }
                          ></div>
                        )}
                      </div>
                    </div>
                    <div
                      className="underline-contact"
                      style={{
                        width: "90%",
                        margin: "0.75rem auto 0 auto",
                      }}
                    ></div>

                    {activeHeading === "1" &&
                      (companysContact === "DontWantTrue" ? (
                        // open it when we add companys contact
                        <div className="p-4">
                          {/* companys contact Basic information */}
                          <div className="pt-3">
                            <p className="companysContactinform mb-0">
                              Basic Information
                            </p>

                            <div className="asc-input-container" id="ascInput">
                              <label
                                className="asc-label-top ClientNameText"
                                style={{ background: "#fff" }}
                              >
                                Email
                              </label>

                              <label className="asc-label-top projectNameTextBoth">
                                Add another
                                <img
                                  src={plusIcon}
                                  className="ms-2 pointer"
                                  alt=""
                                />
                              </label>

                              <input
                                type="text"
                                // disabled
                                className="asc_NormalInput ps-4"
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  color: "#323232",
                                  width: "100%",
                                  background: "white",
                                }}
                                placeholder="Type an Email"
                                value={companysContsEmail}
                                onChange={(e) => {
                                  setCompanysContsEmail(e.target.value);
                                  setChangeComp("asc");
                                }}
                              />
                            </div>

                            <div className="row">
                              <div
                                className="asc-input-container col-md-6 col-12"
                                id="ascInput"
                              >
                                <label
                                  className="asc-label-top ClientNameText"
                                  style={{ background: "#fff" }}
                                >
                                  Mobile Number
                                </label>

                                <PhoneInput
                                  country={"nl"}
                                  enableSearch={true}
                                  className="pt-1 contactDeliveryInput ps-4 bordered-inputs"
                                  placeholder="Contact Telephone"
                                  value={companysContsMobile}
                                  onChange={(phone) => {
                                    setCompanysContsMobile(phone);
                                    setChangeComp(phone);
                                  }}
                                  // defaultCountry={'in'}
                                  // inputProps={{
                                  //   name: 'phone',
                                  //   required: true,
                                  //   autoFocus: true,
                                  // }}
                                />
                              </div>

                              <div
                                className="asc-input-container col-md-6 col-12"
                                id="ascInput"
                              >
                                <label
                                  className="asc-label-top ClientNameText"
                                  style={{ background: "#fff" }}
                                >
                                  Office Telephone
                                </label>

                                <PhoneInput
                                  country={"nl"}
                                  enableSearch={true}
                                  className="pt-1 contactDeliveryInput ps-4 bordered-inputs"
                                  placeholder="Contact Telephone"
                                  value={companysContsOfficeTelNo}
                                  onChange={(phone) => {
                                    setCompanysContsOfficeTelNo(phone);
                                    setChangeComp(phone);
                                  }}
                                  // defaultCountry={'in'}
                                  // inputProps={{
                                  //   name: 'phone',
                                  //   required: true,
                                  //   autoFocus: true,
                                  // }}
                                />
                              </div>
                            </div>
                          </div>
                          {/* companys contact General information */}
                          <div className="pt-5">
                            <p className="companysContactinform mb-0">
                              {/* General Information */}
                              {t("General information")}
                            </p>
                            <div className="row">
                              <div
                                className="asc-input-container col-md-6 col-12"
                                id="ascInput"
                              >
                                <label
                                  className="asc-label-top ClientNameText"
                                  style={{ background: "#fff" }}
                                >
                                  BirthDate
                                </label>

                                <div
                                  className="asc_NormalInput pt-3 ps-4"
                                  style={{
                                    width: "auto",
                                    background: "unset",
                                  }}
                                >
                                  ASC
                                </div>
                              </div>

                              <div
                                className="asc-input-container col-md-6 col-12"
                                id="ascInput"
                              >
                                <label
                                  className="asc-label-top ClientNameText"
                                  style={{ background: "#fff" }}
                                >
                                  Relationship
                                </label>

                                <div
                                  className="asc_NormalInput pt-3 ps-4"
                                  style={{
                                    width: "auto",
                                    background: "unset",
                                  }}
                                >
                                  ASC
                                </div>
                              </div>
                            </div>

                            <div className="asc-input-container" id="ascInput">
                              <label
                                style={{
                                  marginTop: "6px",
                                }}
                                className="asc-label-top projectNameText"
                              >
                                Notes
                                {/* {FetchTranslationList[31]?.translation} */}
                              </label>

                              <textarea
                                style={{
                                  marginTop: "6px",
                                  height: "100px",
                                }}
                                id="w3review"
                                name="w3review"
                                rows="4"
                                cols="50"
                                // placeholder="Notes"
                                className="notesInput ps-3 bordered-inputs"
                                value={companysContsNotes}
                                onChange={(e) => {
                                  setCompanysContsNotes(e.target.value);
                                  setChangeComp(e.target.value);
                                }}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      ) : (
                        // Default Information Tab start👇.
                        <div className="information-block">
                          <div className="basic-info-block">
                            <p className="basic-text">
                              {t("Basic information")}
                            </p>
                            {emails?.map((email, index) => {
                              return (
                                <div key={index}>
                                  <div
                                    className={
                                      roleAccess ===
                                      process.env.REACT_APP_IS_VIEWER
                                        ? "pointerEvent"
                                        : ""
                                    }
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <input
                                      style={{ width: "97%" }}
                                      className="input-style add-contact-input-style border-black"
                                      type="email"
                                      name="email"
                                      value={email.email}
                                      onChange={(e) => {
                                        let data = [...emails];
                                        data[index][e.target.name] =
                                          e.target.value;
                                        setEmails(data);
                                        setChangeComp(data);
                                        setEmailErr();
                                        handleEmailChange(e, index);
                                        setDisableButton(false);
                                      }}
                                    />
                                    {index === 0 ? (
                                      emails.length !== 2 && (
                                        <img
                                          alt=""
                                          disabled
                                          src={Plusicon}
                                          style={{
                                            color: `${primaryColor}`,
                                            cursor: "pointer",
                                          }}
                                          className="responsive-check ps-1 mb-1"
                                          onClick={() => {
                                            if (emails.length === 2) {
                                              return;
                                            } else {
                                              if (
                                                email.type === "Personal Email"
                                              ) {
                                                let newEmail = {
                                                  email: "",
                                                  type: "Professional Email",
                                                };
                                                setEmails([
                                                  ...emails,
                                                  newEmail,
                                                ]);
                                              } else {
                                                let newEmail = {
                                                  email: "",
                                                  type: "Personal Email",
                                                };
                                                setEmails([
                                                  ...emails,
                                                  newEmail,
                                                ]);
                                              }
                                            }
                                          }}
                                        />
                                      )
                                    ) : (
                                      <img
                                        alt=""
                                        src={Minusicon}
                                        style={{
                                          color: `${primaryColor}`,
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          let data = [...emails];
                                          data.splice(index, 1);
                                          setEmails(data);
                                        }}
                                        className="responsive-check ps-1 mb-1"
                                      />
                                    )}
                                  </div>

                                  <div
                                    className={
                                      emailErrors[index]
                                        ? "underline-contact1"
                                        : "underline-contact"
                                    }
                                  ></div>
                                  <AppInputBelowDropDown
                                    width={184}
                                    disabled={isRole(ROLES.VIEWER)}
                                    optionList={emailTypeoptions}
                                    optionKey="value"
                                    optionValue="value"
                                    onSelect={(newValue) => {
                                      let data = [...emails];
                                      data[index]["type"] = newValue;
                                      setEmails(data);
                                    }}
                                    selected={email.type}
                                    error={emailErrors[index]}
                                  />
                                  {/* {emailErrors[index] && (
                                  <div className="warning">
                                    <i className="mt-2 bi bi-exclamation-circle"></i>
                                    &nbsp; Incorrect email
                                  </div>
                                )} */}
                                </div>
                              );
                            })}
                            <div className="row mt-4">
                              <div className="col-12 col-lg-6">
                                {mobiles?.map((mobile, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className={
                                        roleAccess ===
                                        process.env.REACT_APP_IS_VIEWER
                                          ? "pointerEvent"
                                          : ""
                                      }
                                    >
                                      <div
                                        className="d-flex"
                                        style={{ height: "25px" }}
                                      >
                                        <PhoneInput
                                          country={"nl"}
                                          enableSearch={true}
                                          value={mobile.phoneNumber}
                                          // onChange={(phone) => setMobiles(phone)}
                                          onChange={(phone) => {
                                            let data = [...mobiles];
                                            data[index]["phoneNumber"] = phone;
                                            setMobiles(data);
                                            setChangeComp(data);
                                          }}
                                          className="flag-inputcontact border-black"
                                        />
                                        {index === 0 ? (
                                          mobiles.length !== 3 && (
                                            <img
                                              alt=""
                                              src={Plusicon}
                                              style={{
                                                color: `${primaryColor}`,
                                                cursor: "pointer",
                                                width: "24px",
                                              }}
                                              className="responsive-check mb-1 ps-2"
                                              onClick={() => {
                                                if (mobiles.length === 3) {
                                                  return;
                                                } else {
                                                  if (
                                                    mobile.type ===
                                                    "Professional Mobile"
                                                  ) {
                                                    // let newMobile = {
                                                    //   phoneNumber: "",
                                                    //   type: "Personal Mobile",
                                                    // }
                                                    // setMobiles([
                                                    //   ...mobiles,
                                                    //   newMobile,
                                                    // ]);
                                                  }
                                                  const key = "type";
                                                  const value = "Office Number";
                                                  const exists = mobiles.some(
                                                    (obj) => obj[key] === value,
                                                  );
                                                  if (exists) {
                                                    let newMobile = {
                                                      phoneNumber: "",
                                                      type: "Personal Mobile",
                                                    };
                                                    setMobiles([
                                                      ...mobiles,
                                                      newMobile,
                                                    ]);
                                                  } else {
                                                    let newMobile = {
                                                      phoneNumber: "",
                                                      type: "Office Number",
                                                    };
                                                    setMobiles([
                                                      ...mobiles,
                                                      newMobile,
                                                    ]);
                                                  }
                                                }
                                              }}
                                            />
                                          )
                                        ) : (
                                          <img
                                            alt=""
                                            src={Minusicon}
                                            style={{
                                              color: `${primaryColor}`,
                                              cursor: "pointer",
                                              // fontSize: "1.2rem",
                                            }}
                                            onClick={() => {
                                              let data = [...mobiles];
                                              data.splice(index, 1);
                                              setMobiles(data);
                                            }}
                                            className="responsive-check ps-2 mb-1"
                                          />
                                        )}
                                      </div>
                                      <div className="underline-contact"></div>
                                      <AppInputBelowDropDown
                                        optionList={mobilePhoneTypeoptions}
                                        optionKey="value"
                                        optionValue="value"
                                        onSelect={(newValue) => {
                                          let data = [...mobiles];
                                          data[index]["type"] = newValue;
                                          setMobiles(data);
                                          setChangeComp(data);
                                        }}
                                        selected={mobile.type || "Select"}
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                              <div
                                className={
                                  roleAccess === process.env.REACT_APP_IS_VIEWER
                                    ? "pointerEvent col-12 col-lg-6"
                                    : "col-12 col-lg-6"
                                }
                              >
                                {addresses.map((address, index) => {
                                  return (
                                    <div key={index}>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          height: "25px",
                                        }}
                                        className="componentB-container"
                                      >
                                        <GooglePlacesAutocomplete
                                          debounce={800}
                                          placeholder=""
                                          onSelect={async (e) => {
                                            handleAddressSelect(
                                              e,
                                              address.type,
                                            );
                                            setChangeComp("asc");
                                          }}
                                          initialValue={address.address}
                                        />
                                        {index === 0 ? (
                                          addresses.length !== 2 && (
                                            <img
                                              alt=""
                                              src={Plusicon}
                                              style={{
                                                color: `${primaryColor}`,
                                                cursor: "pointer",
                                                width: "20px",
                                              }}
                                              className="responsive-check ps-1 mb-1"
                                              onClick={() => {
                                                if (addresses.length === 2) {
                                                  return;
                                                } else {
                                                  if (
                                                    address.type ===
                                                    "Professional Address"
                                                  ) {
                                                    let newAddress = {
                                                      address: "",
                                                      type: "Personal Address",
                                                      street: "",
                                                      city: "",
                                                      state: "",
                                                      pinCode: "",
                                                      country: "",
                                                    };
                                                    setAddresses([
                                                      ...addresses,
                                                      newAddress,
                                                    ]);
                                                  } else {
                                                    let newAddress = {
                                                      address: "",
                                                      type: "Professional Address",
                                                      street: "",
                                                      city: "",
                                                      state: "",
                                                      pinCode: "",
                                                      country: "",
                                                    };
                                                    setAddresses([
                                                      ...addresses,
                                                      newAddress,
                                                    ]);
                                                  }
                                                }
                                              }}
                                            />
                                          )
                                        ) : (
                                          <img
                                            alt=""
                                            src={Minusicon}
                                            style={{
                                              color: `${primaryColor}`,
                                              cursor: "pointer",
                                              width: "20px",
                                            }}
                                            className="responsive-check ps-1"
                                            onClick={() => {
                                              let data = [...addresses];
                                              data.splice(index, 1);
                                              setAddresses(data);
                                            }}
                                          />
                                        )}
                                      </div>

                                      <div className="underline-contact"></div>
                                      <AppInputBelowDropDown
                                        disabled={isRole(ROLES.VIEWER)}
                                        optionList={mobileTypeoptions}
                                        optionKey="value"
                                        optionValue="value"
                                        onSelect={(newValue) => {
                                          let data = [...addresses];
                                          data[index]["type"] = newValue;
                                          setAddresses(data);
                                          setChangeComp(data);
                                        }}
                                        selected={address.type || "Select"}
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            </div>

                            {/* <div className="general-finance-flex"> */}
                            <div
                              className="row new-general-finance"
                              style={{
                                width: "100%",
                                marginRight: "0",
                                marginLeft: "0",
                              }}
                            >
                              {/* /////////////GENERAL INFORMATION/////////////////////////// */}
                              {/* <Wrapper> */}

                              <div
                                className="row general-finance"
                                style={{ "--bs-gutter-x": "0" }}
                              >
                                <div
                                  // id="controlled-tab-example"
                                  // activeKey={key}
                                  // onSelect={(k) => setKey(k)}
                                  className="p-0"
                                >
                                  <div
                                    // eventKey="home"
                                    className="gernel-info pt-3"
                                  >
                                    <p className="basic-text">
                                      {t("General information")}
                                    </p>
                                    <>
                                      <div className="row" style={{}}>
                                        <div className="col-12 col-lg-6">
                                          <div
                                            style={{ height: "25px" }}
                                            className={
                                              roleAccess ===
                                              process.env.REACT_APP_IS_VIEWER
                                                ? "pointerEvent d-flex justify-content-between"
                                                : "d-flex justify-content-between"
                                            }
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                width: "94%",
                                                alignItems: "center",
                                              }}
                                              id="CalendarCssRT"
                                            >
                                              <img
                                                src={Calendericon}
                                                alt="calender"
                                                className="calender-icon"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  setCalendarIsOpen((p) => !p);
                                                }}
                                                style={{
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                              />
                                              <AppDatePicker
                                                open={calendarIsOpen}
                                                onOpenChange={(open) =>
                                                  setCalendarIsOpen(open)
                                                }
                                                isError={dateError}
                                                error={setDateError}
                                                onSelect={(d, event) => {
                                                  setDateError(false);
                                                  event.preventDefault();
                                                }}
                                                selected={birthDate}
                                                onChange={setBirthDate}
                                                inputClassNames={"ms-3"}
                                                dateFormat="dd/MM/yyyy"
                                                className="calender-icon-date border-black ps-2"
                                                isDisabledForFuture={true}
                                              />
                                            </label>
                                          </div>
                                          <div
                                            className={
                                              dateError
                                                ? "underline-contact-warning"
                                                : "underline-contact"
                                            }
                                          ></div>
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "10px",
                                            }}
                                          >
                                            <p
                                              className="text-heading-styles"
                                              // style={{ opacity: "0.5" }}
                                              // style={{ opacity: "0.5" }}
                                            >
                                              {/* Birth Date */}
                                              {t("Birth Date")}
                                            </p>
                                            {dateError && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  gap: "5px",
                                                }}
                                              >
                                                <p
                                                  style={{ marginTop: "4px" }}
                                                  class="warning-icon-small"
                                                >
                                                  !
                                                </p>
                                                <p
                                                  style={{ marginTop: "3px" }}
                                                  class=" warning-message-small"
                                                >
                                                  Please select a valid date.
                                                </p>
                                              </div>
                                            )}
                                          </div>
                                        </div>

                                        <div
                                          className={
                                            roleAccess ===
                                            process.env.REACT_APP_IS_VIEWER
                                              ? "pointerEvent col-12 col-lg-6"
                                              : "col-12 col-lg-6"
                                          }
                                        >
                                          <div
                                            ref={refMarital}
                                            style={{
                                              cursor: "pointer",
                                              position: "relative",
                                              display: "flex",
                                              justifyContent: "space-between",
                                            }}
                                            onClick={() =>
                                              setShowMaritalStatusDrop(
                                                !showMaritalStatusDrop,
                                              )
                                            }
                                            className=""
                                          >
                                            <p
                                              className="margin-0"
                                              style={{
                                                marginLeft: "3px",
                                                height: "25px",
                                                color: "rgb(51, 51, 51)",
                                                fontSize: "14px",
                                                fontWeight: 400,
                                              }}
                                              onClick={() =>
                                                setShowMaritalStatusDrop(
                                                  !showMaritalStatusDrop,
                                                )
                                              }
                                            >
                                              {marital}
                                            </p>
                                            <BsChevronDown
                                              size={10}
                                              style={{
                                                marginTop: "5px",
                                                marginRight: "5px",
                                                flexGlow: "1",
                                                color: "#333333",
                                              }}
                                              onClick={() =>
                                                setShowMaritalStatusDrop(
                                                  !showMaritalStatusDrop,
                                                )
                                              }
                                              className={`${
                                                showMaritalStatusDrop
                                                  ? "down-arrow down-arrow-rotate bi-paperclip"
                                                  : "down-arrow bi-paperclip"
                                              }`}
                                            />

                                            {showMaritalStatusDrop && (
                                              <div
                                                className="drop-down-maried pb-2"
                                                style={{ width: "100%" }}
                                              >
                                                {/* <div>
                                                <p
                                                  className="margin-0 ps-3"
                                                  style={{
                                                    color: "#333333",
                                                    fontSize:
                                                      "clamp(14px, 1.025vw, 0.833vw)",
                                                  }}

                                                >
                                                  -
                                                </p>
                                              </div> */}
                                                {maritailOptions?.map(
                                                  (item, i) => {
                                                    return (
                                                      <div
                                                        key={i}
                                                        className={
                                                          item?.value ===
                                                          marital
                                                            ? " typ-list-select typ-list ulterDrop"
                                                            : "typ-list ulterDrop"
                                                        }
                                                      >
                                                        <p
                                                          key={i}
                                                          className="margin-0 ps-3"
                                                          onClick={() => {
                                                            setMarital(
                                                              item.value,
                                                            );
                                                            setShowMaritalStatusDrop(
                                                              false,
                                                            );
                                                          }}
                                                        >
                                                          {item.value}
                                                        </p>
                                                      </div>
                                                    );
                                                  },
                                                )}
                                              </div>
                                            )}
                                          </div>

                                          <div className="underline-contact"></div>
                                          <p className="text-heading-styles">
                                            {t("Marital Status")}
                                          </p>
                                        </div>
                                      </div>
                                    </>
                                  </div>
                                </div>
                              </div>
                              <div className="row"></div>
                            </div>

                            <div
                              className={
                                roleAccess === process.env.REACT_APP_IS_VIEWER
                                  ? "pointerEvent row tag-div2 mt-5"
                                  : "row tag-div2 mt-5"
                              }
                            >
                              <div className="col-12 col-lg-6">
                                <div
                                  style={{
                                    cursor: "pointer",
                                    position: "relative",
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                  onClick={() =>
                                    setShowRelationShipDrop(
                                      !showRelationShipDrop,
                                    )
                                  }
                                  ref={refRelationshipManager}
                                >
                                  <p
                                    className="margin-0 "
                                    style={{
                                      // marginLeft: "3px",
                                      fontSize: "14px",
                                      color: "#333333",
                                      flexGrow: "1",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {relationship ? relationship : "Select"}
                                  </p>
                                  <BsChevronDown
                                    size={10}
                                    style={{
                                      marginTop: "5px",
                                      flexGlow: "1",
                                      color: "#333333",
                                    }}
                                    className={`${
                                      showRelationShipDrop
                                        ? "down-arrow down-arrow-rotate bi-paperclip"
                                        : "down-arrow bi-paperclip"
                                    }`}
                                  />
                                  {showRelationShipDrop && (
                                    <div
                                      className="drop-down-noti1"
                                      style={{ width: "18vw" }}
                                      id="lang-drop-down"
                                    >
                                      {typeoptions?.map((item, i) => {
                                        return (
                                          <div
                                            key={i}
                                            className={
                                              item.value === relationship
                                                ? "typ-list-select typ-list ulterDrop"
                                                : "typ-list ulterDrop"
                                            }
                                            // className=''
                                          >
                                            <p
                                              key={i}
                                              className="margin-0 ms-1 pb-1"
                                              style={{
                                                opacity: 1,
                                              }}
                                              onClick={() => {
                                                setRelationship(item.value);
                                                setShowRelationShipDrop(false);
                                              }}
                                            >
                                              {item.value}
                                            </p>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  )}
                                </div>
                                <div className="underline-contact"></div>
                                <p className="text-heading-styles">
                                  {/* Relationship */}
                                  {t("Relationship")}
                                </p>
                              </div>

                              <div className="col-12 col-lg-6">
                                <div
                                  ref={refAccountManager}
                                  style={{
                                    position: "relative",
                                    cursor: "pointer",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      width: "100%",
                                    }}
                                    onClick={() => {
                                      setShowAccountManagerDrop(
                                        !showAccountManagerDrop,
                                      );
                                    }}
                                  >
                                    <p
                                      className="margin-0 ms-18-bold Client-input-service"
                                      style={{
                                        color: "#333333",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                      }}
                                      onClick={() => {
                                        setShowAccountManagerDrop(
                                          !showAccountManagerDrop,
                                        );
                                      }}
                                    >
                                      {(jobname && jobname) || "Select"}
                                    </p>
                                    <i
                                      className="bi bi-chevron-down fw-bold"
                                      style={{
                                        fontSize: "10px",
                                        color: "#333333",
                                        marginRight: "5px",
                                      }}
                                    ></i>
                                  </div>

                                  {showAccountManagerDrop && (
                                    <div className="client-drop-servic p-0">
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                        onClick={() => {
                                          setShowAccountManagerDrop(false);
                                        }}
                                      ></div>

                                      <div
                                        className="client-search-main1 account-manager-dropdown px-2"
                                        style={{ marginBottom: "10px" }}
                                      >
                                        <input
                                          type="text"
                                          value={clientSearch}
                                          style={{
                                            margin: "0 0 0 0rem",
                                            opacity: "0.5",
                                            borderBottom: "1px solid #a5a5a5",
                                            color: "#A5A5A5",
                                            fontsize: "14px",
                                            fontWeight: clientSearch
                                              ? "400"
                                              : "300",
                                          }}
                                          placeholder="Search"
                                          className="search-style select-client-div border-black py-1"
                                          onChange={(e) => {
                                            setClientSearch(e.target.value);
                                          }}
                                        />
                                      </div>
                                      <div className="service-list-hieght">
                                        {managerList?.data
                                          ?.filter((data) =>
                                            data?.managername
                                              ?.toLowerCase()
                                              .includes(
                                                clientSearch?.toLowerCase(),
                                              ),
                                          )
                                          .map((project, i) => {
                                            let existItem = false;
                                            if (
                                              accountManagerId ===
                                              project.managerid
                                            ) {
                                              existItem = true;
                                            }
                                            return (
                                              <>
                                                <div
                                                  style={{
                                                    backgroundColor: existItem
                                                      ? "#d8d8e5"
                                                      : "",
                                                  }}
                                                  className="d-flex pt-1 pb-1 ulterDrop"
                                                >
                                                  {project?.managerimage ? (
                                                    <img
                                                      alt=""
                                                      src={
                                                        project?.managerimage
                                                      }
                                                      height="24px"
                                                      width="24px"
                                                      style={{
                                                        borderRadius: "50px",
                                                      }}
                                                    />
                                                  ) : (
                                                    <div
                                                      style={{
                                                        borderRadius: "50px",
                                                        height: "24px",
                                                        width: "24px",
                                                        backgroundColor:
                                                          "#95A7C6",
                                                        color: "#FFFFFF",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                        fontSize: "12px",
                                                        fontWeight: "bold",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      {project?.managername
                                                        ?.slice(0, 2)
                                                        .toUpperCase()}
                                                      {/* <p
                                                      style={{
                                                        fontSize: "14px",
                                                      }}
                                                    >
                                                    
                                                    </p> */}
                                                    </div>
                                                  )}

                                                  <p
                                                    className="margin-0 ps-2"
                                                    key={i}
                                                    style={{
                                                      textTransform:
                                                        "capitalize",
                                                    }}
                                                    onClick={() => {
                                                      // let listcontactid = project?.id;
                                                      // let contactname = project?.name;
                                                      // let contacttype = project?.type;
                                                      setAccountManagerId(
                                                        project?.managerid,
                                                      );
                                                      setJobname(
                                                        project?.managername,
                                                      );
                                                      setChangeComp(
                                                        project?.managername,
                                                      );
                                                      setShowAccountManagerDrop(
                                                        false,
                                                      );
                                                    }}
                                                  >
                                                    {project?.managername}
                                                  </p>
                                                </div>
                                              </>
                                            );
                                          })}
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="underline-contact"></div>
                                <p className="text-heading-styles">
                                  {t("Account Manager")}
                                </p>
                              </div>

                              <div className="col-12 col-lg--6 col-lg-12">
                                <div
                                  style={{
                                    cursor: "pointer",
                                    position: "relative",
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                  onClick={() =>
                                    setShowPriorityDrop(!showPriorityDrop)
                                  }
                                  ref={refPriority}
                                >
                                  <p
                                    className="margin-0 "
                                    style={{
                                      // marginLeft: "3px",
                                      fontSize: "14px",
                                      color: "#333333",
                                      flexGrow: "1",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {priority ? priority : "Select"}
                                  </p>
                                  <BsChevronDown
                                    size={10}
                                    style={{
                                      marginTop: "5px",
                                      flexGlow: "1",
                                      color: "#333333",
                                    }}
                                    className={`${
                                      showPriorityDrop
                                        ? "down-arrow down-arrow-rotate bi-paperclip"
                                        : "down-arrow bi-paperclip"
                                    }`}
                                  />
                                  {showPriorityDrop && (
                                    <div
                                      className="drop-down-noti1"
                                      style={{ width: "18vw" }}
                                      id="lang-drop-down"
                                    >
                                      {priorityOptions?.map((item, i) => {
                                        return (
                                          <div
                                            key={i}
                                            className={
                                              item.value === priority
                                                ? "typ-list-select typ-list ulterDrop"
                                                : "typ-list ulterDrop"
                                            }
                                            // className=''
                                          >
                                            <p
                                              key={i}
                                              className="margin-0 ms-1 pb-1"
                                              style={{
                                                opacity: 1,
                                              }}
                                              onClick={() => {
                                                setPriority(item.label);
                                                setPriorityId(item.value);
                                                setShowPriorityDrop(false);
                                              }}
                                            >
                                              {item.label}
                                            </p>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  )}
                                </div>
                                <div className="underline-contact"></div>
                                <p className="text-heading-styles">
                                  Priority
                                  {/* {fetchTransAddContactList[22]?.translation} */}
                                </p>
                              </div>
                            </div>

                            <div
                              // className="tag-div"
                              className={
                                roleAccess === process.env.REACT_APP_IS_VIEWER
                                  ? "pointerEvent tag-div position-relative"
                                  : "tag-div position-relative"
                              }
                            >
                              <span
                                className="text-heading-styles"
                                style={{
                                  marginTop: "10px",
                                  color: "#333333",
                                  opacity: "1",
                                }}
                              >
                                {t("Tags")}
                              </span>
                              <div
                                onClick={() => onClickTag()}
                                style={{
                                  display: "inline-block",
                                  marginLeft: "1.5rem",
                                  position: "relative",
                                  border: "1px solid #A5A5A5",
                                  borderRadius: "10px",
                                  minHeight: "5.104vw",
                                }}
                              >
                                {tags?.map((tag, index) => {
                                  return (
                                    <span key={index} className="tag-style">
                                      {tag?.tagname}
                                      <span className="cross-icon-style"></span>
                                      <BsX
                                        className="times-icon-style"
                                        onClick={() => {
                                          let temp = [...tags];
                                          temp = temp.filter(
                                            (item) => item != tag,
                                          );
                                          setTags(temp);
                                        }}
                                        style={{
                                          height: "20px",
                                          width: "20px",
                                        }}
                                      />
                                    </span>
                                  );
                                })}
                                <input
                                  type="text"
                                  ref={inputRef}
                                  // placeholder="Type tags"
                                  className="input-style add-contact-input-style w-100 p-2"
                                  value={tagValue}
                                  onKeyUp={(e) => {
                                    if (e.key === "Enter" && e.target.value) {
                                      dispatch(
                                        AddTagsContact(userid, tagValue),
                                      );
                                    } else if (e.target.value) {
                                      setShowTagDrop(true);
                                    }
                                  }}
                                  onChange={(e) => {
                                    setShowTagDrop(true);
                                    setTagValue(e.target.value);
                                    setChangeComp(e.target.value);
                                  }}
                                  onBlur={() => {
                                    setTimeout(() => {
                                      setShowTagDrop(false);
                                    }, 400);
                                  }}
                                />
                              </div>
                              {showTagDrop && tagList.length > 0 && (
                                <div className="tag-dropdown">
                                  {tagList?.map((tag, index) => {
                                    const tagExists = tags.some(
                                      (t) =>
                                        String(t.tagid) === String(tag.tagid),
                                    );
                                    return (
                                      <div
                                        key={index}
                                        className="taglistdiv ulterDrop"
                                      >
                                        <p
                                          key={index}
                                          // className="tag-dropdown-element"
                                          // onClick={() => {
                                          //   tags.push(tag);
                                          //   setTagValue("");
                                          // }}

                                          className={`tag-dropdown-element ${
                                            tagExists ? "added-tag" : ""
                                          }`}
                                          onClick={() => {
                                            if (!tagExists) {
                                              setTags([...tags, tag]);
                                            }
                                            setTagValue("");
                                            setShowTagDrop(true);
                                          }}
                                        >
                                          {tag?.tagname}
                                        </p>
                                        <button
                                          onClick={() => DeleteTag(tag.tagid)}
                                          className="deletebtn deletebtnborder me-3 my-1"
                                        />
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          </div>
                          <div
                            className="mb-5 mb-lg-1"
                            style={{ display: "flex", marginTop: "0.5rem" }}
                          >
                            <p
                              className="text-heading-styles"
                              style={{
                                marginBottom: "5px",
                                color: "#333333",
                                opacity: "1",
                              }}
                            >
                              {t("Notes")}
                            </p>
                            {/* <textarea
                            className="info-notes-style ms-4"
                            value={notes}
                            onChange={(e) => {
                              setNotes(e.target.value);
                              setChangeComp(e.target.value);
                            }}
                          ></textarea> */}
                            <textarea
                              // className="info-notes-style ms-4"
                              className={
                                roleAccess === process.env.REACT_APP_IS_VIEWER
                                  ? "pointerEvent info-notes-style ms-3 border-black"
                                  : "info-notes-style ms-3 border-black"
                              }
                              name="notes"
                              id="notes"
                              value={notes}
                              onChange={(e) => {
                                setNotes(e.target.value);
                                setChangeComp(e.target.value);
                              }}
                              style={{ resize: "auto" }}
                            />
                          </div>
                        </div>
                      ))}

                    {activeHeading === "2" && (
                      <div // riya code start for Doc Drag and Drop
                        className={`doc-block drop-zone ${
                          isDragging ? "drop-zone-active" : ""
                        }`}
                        style={{ marginBottom: "1rem" }}
                        onDragOver={(e) => e.preventDefault()} // Prevent default to allow drop doc
                        onDrop={(e) => {
                          handleDrop(e);
                          setIsDragging(false); // Reset dragging state after doc drop
                        }}
                        onDragLeave={(e) => {
                          e.preventDefault();
                          setIsDragging(false); // Update state to remove doc drop zone visual feedback
                        }}
                        onDragEnter={() => setIsDragging(true)} // riya code end for Doc Drag and Drop
                      >
                        <div
                          className="doc-table-headings"
                          style={{ marginBottom: "1rem" }}
                        >
                          <p
                            className="doc-table-heading"
                            style={{
                              color: "#A5A5A5",
                              fontWeight: "500",
                              width: "60px",
                            }}
                          >
                            {t("Actions")}
                          </p>
                          <p
                            className="doc-table-heading"
                            style={{ color: "#A5A5A5", fontWeight: "500" }}
                          >
                            {t("File title")}
                          </p>
                          <p
                            className="doc-table-heading ascHideForMobile HideForTablet"
                            style={{ color: "#A5A5A5", fontWeight: "500" }}
                          >
                            {t("Uploaded by")}
                          </p>
                          <p
                            className="doc-table-heading"
                            style={{ color: "#A5A5A5", fontWeight: "500" }}
                          >
                            {t("Date")}
                          </p>
                        </div>
                        {contactDocsList?.map((doc, index) => {
                          return (
                            <div // riya code start for Doc Drag and Drop
                              key={index}
                              className={`doc-table-headings cursor-pointer ${
                                isDragging ? "drop-zone-active" : ""
                              }`}
                              style={{ marginBottom: "8px" }} // riya code end for Doc Drag and Drop
                            >
                              <div
                                className="task-grid-lines"
                                style={{ opacity: "60%", width: "60px" }}
                              >
                                <RiDeleteBinLine
                                  style={{
                                    color: "black",
                                    fontSize: "1.3rem",
                                    curosor: "pointer",
                                  }}
                                  onClick={() => {
                                    setDeleteRowIndex(doc.documentid);
                                    setDeleteDocument(true);
                                  }}
                                />
                              </div>
                              <LightTooltip
                                // title={doc?.filename || doc?.documentname}

                                title={
                                  doc?.filename?.length > 30 ||
                                  doc?.documentname?.length > 30
                                    ? doc?.filename || doc?.documentname
                                    : ""
                                }
                                placement="top-start"
                              >
                                <div
                                  onMouseOver={() => {
                                    if (
                                      doc?.filename?.length > 30 ||
                                      doc?.documentname?.length > 30
                                    ) {
                                      setFulLenghtDocAddContact(true);
                                    }
                                  }}
                                  onMouseOut={() => {
                                    setFulLenghtDocAddContact(false);
                                  }}
                                  style={{ width: "14vw", cursor: "pointer" }}
                                  className="truncated-text1"
                                  onClick={(e) => {
                                    if (isUpdating) {
                                      handleDownloadContact(
                                        e,
                                        doc?.documentid,
                                        doc.filename,
                                      );
                                    }
                                  }}
                                >
                                  {" "}
                                  {doc?.filename || doc?.documentname}
                                </div>
                              </LightTooltip>

                              <p className="doc-table-heading table-content ascHideForMobile HideForTablet">
                                {doc?.uploadedby ||
                                  firstupname + " " + lastupname}
                              </p>
                              <p className="doc-table-heading table-content">
                                {moment(doc?.date).format("DD.MMM.YYYY")}

                                <EyeOutlined
                                  className="ms-3"
                                  onClick={() => {
                                    setFilePreview(
                                      getFilePreview({
                                        // file: file, // local upload file
                                        url: doc.link,
                                        type: doc.link.split(".").pop(),
                                        name: doc.documentname,
                                      }),
                                    );
                                  }}
                                />
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    <FilePreviewModal
                      open={filePreview}
                      file={filePreview}
                      onClose={() => setFilePreview(null)}
                    />

                    {activeHeading === "3" && (
                      <div className="task-block">
                        <div
                          className="task-table-grid3"
                          style={{
                            gridTemplateColumns: "15% 30% 20% 15% 10%",
                          }}
                        >
                          <div className="task-grid-lines-heading">
                            {t("Actions")}
                          </div>
                          <div className="task-grid-lines-heading">
                            {t("Task Name")}
                          </div>
                          <div className="task-grid-lines-heading">
                            {t("Deadline")}
                          </div>
                          <div className="task-grid-lines-heading"></div>
                          <div className="task-grid-lines-heading ascHideForMobile HideForTablet">
                            {t("Complete?")}
                          </div>
                        </div>
                        {allTasks?.map((task) => {
                          return (
                            <div className="task-table-grid3" key={task.taskid}>
                              <div
                                // className="task-grid-lines"
                                className={
                                  roleAccess === process.env.REACT_APP_IS_VIEWER
                                    ? "pointerEvent task-grid-lines"
                                    : "task-grid-lines"
                                }
                                style={{ opacity: "60%" }}
                              >
                                <RiDeleteBinLine
                                  style={{
                                    color: "black",
                                    fontSize: "1.3rem",
                                    curosor: "pointer",
                                  }}
                                  onClick={() => {
                                    // dispatch(deleteTask(task.taskid));
                                    setShowPopup(true);
                                    setTaskIdforDelete(task.taskid);
                                  }}
                                />
                              </div>
                              <div
                                className="task-grid-lines task-main-line pointer"
                                onClick={() =>
                                  handleOpenUpdateTaskPopup(task.taskid)
                                }
                              >
                                {task.taskname}
                              </div>
                              <div
                                className="task-grid-lines task-main-line pointer"
                                onClick={() =>
                                  handleOpenUpdateTaskPopup(task.taskid)
                                }
                              >
                                {moment(task.deadline).format("DD.MM.YYYY")}
                              </div>
                              <div
                                className="task-grid-lines task-main-line pointer"
                                onClick={() =>
                                  handleOpenUpdateTaskPopup(task.taskid)
                                }
                              >
                                {`${
                                  task.deadline.split("T")[1].split(":")[0]
                                }:${task.deadline.split("T")[1].split(":")[1]}`}
                              </div>
                              <div
                                className="task-grid-lines ascHideForMobile HideForTablet"
                                style={{ opacity: "1" }}
                              >
                                <input
                                  type="checkbox"
                                  id={`switchToggle${task.taskid}`}
                                  className="checkbox"
                                  checked={
                                    task.statusname.toUpperCase() ===
                                      "COMPLETE" ||
                                    task.statusname.toUpperCase() ===
                                      "COMPLETED"
                                      ? 1
                                      : 0
                                  }
                                  onChange={() =>
                                    dispatch(
                                      updateTaskStatus2(
                                        companyids,
                                        task.taskid,
                                      ),
                                    )
                                  }
                                />
                                <label
                                  htmlFor={`switchToggle${task.taskid}`}
                                  className="toggle"
                                >
                                  {/* <p className='text-center mt-2 textClrSign'></p> */}
                                </label>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                    {activeHeading === "4" && (
                      // emails?[0].email || ""
                      <div>
                        <div>
                          {emailSource === "gmail" ? (
                            <ContactEmails
                              fromEmail={
                                Boolean(emails) &&
                                Array.isArray(emails) &&
                                emails.length > 0
                                  ? emails[0].email
                                  : ""
                              }
                              emailSource={emailSource}
                              setEmailSource={setEmailSource}
                            />
                          ) : (
                            <OutlookContactEmails
                              fromEmail={
                                Boolean(emails) &&
                                Array.isArray(emails) &&
                                emails.length > 0
                                  ? emails[0].email
                                  : ""
                              }
                              emailSource={emailSource}
                              setEmailSource={setEmailSource}
                            />
                          )}
                        </div>
                      </div>
                    )}
                    {activeHeading === "5" && (
                      <div className="task-table-grid2">
                        <div className="task-grid-lines"></div>
                        <div className="task-grid-lines">Subject</div>
                        <div className="task-grid-lines">Date</div>
                        <div className="task-grid-lines"></div>
                      </div>
                    )}
                    {/* {activeHeading === "4" && <div>Emails</div>} */}
                    {/* {activeHeading === "5" && <div>Events</div>} */}
                  </div>
                </>
              ) : (
                // <ContactTaskBlock
                //   Image3={Image3}
                //   primaryColor={primaryColor}
                //   AiOutlineCloseCircle={AiOutlineCloseCircle}
                //   setShowPriorityDrop={setShowPriorityDrop}
                //   setPriorityName={setPriorityName}
                //   setPriorityId={setPriorityId}
                //   priorityName={priorityName}
                //   priorityData={priorityData}
                //   showPriorityDrop={showPriorityDrop}
                //   setStatusName={setStatusName}
                //   setStatusId={setStatusId}
                //   BsChevronDown={BsChevronDown}
                //   statusData={statusData}
                //   showStatusDrop={showStatusDrop}
                //   setShowStatusDrop={setShowStatusDrop}
                //   setShowNotiDropDown={setShowNotiDropDown}
                //   setNotiTime={setNotiTime}
                //   notificationTimes={notificationTimes}
                //   showNotiDropDown={showNotiDropDown}
                //   setNMinutes={setNMinutes}
                //   nminutes={nminutes}
                //   NotiBell={NotiBell}
                //   Clock={Clock}
                //   setMinutes={setMinutes}
                //   minutes={minutes}
                //   setHours={setHours}
                //   hours={hours}
                //   TaskCardCalendar={TaskCardCalendar}
                //   dueDate={dueDate}
                //   setDueDate={setDueDate}
                //   DatePicker={DatePicker}
                //   Wrapper={Wrapper}
                //   AssigneeIcon={AssigneeIcon}
                //   setShowDropPeople={setShowDropPeople}
                //   setAssigneeIdMain={setAssigneeIdMain}
                //   setAssignee={setAssignee}
                //   docPeopleList={docPeopleList}
                //   setSearchPeople={setSearchPeople}
                //   searchPeople={searchPeople}
                //   FiSearch={FiSearch}
                //   showDropPeople={showDropPeople}
                //   assignee={assignee}
                //   setDescription={setDescription}
                //   description={description}
                //   setTaskName={setTaskName}
                //   taskName={taskName}
                //   setDocAdded={setDocAdded}
                //   setShowTaskColumn={setShowTaskColumn}
                //   notiTime={notiTime}
                //   statusName={statusName}
                // />
                <div></div>
              )}
            </>
          ) : (
            <div className="column-2-info">
              <div
                className="doc-heading"
                style={{ margin: "2rem auto 0 auto" }}
              >
                <div>
                  <img
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "0.25rem",
                    }}
                  />
                  <span
                    className="doc-heading-bold"
                    style={{ color: `${primaryColor}` }}
                  >
                    new DOc
                  </span>
                </div>
                <div>
                  <AiOutlineCloseCircle
                    style={{
                      fontSize: "1.4rem",
                      color: "#707070",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setDocAdded(false);
                      setShowTaskColumn(false);
                    }}
                  />
                </div>
              </div>
              <div className="upload-new-doc">
                <AiFillPlusCircle
                  style={{
                    color: `${primaryColor}`,
                    cursor: "pointer",
                    fontSize: "var(--responsive-font-18)",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    selectDoc.current.click();
                  }}
                />
                <input
                  type="file"
                  accept=".doc,.pdf,.xls,.xlsx,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  name="doc"
                  id="doc"
                  style={{ display: "none" }}
                  ref={selectDoc}
                />
                <span
                  className="text-heading-styles"
                  style={{ fontSize: "14px" }}
                >
                  Upload a new Doc
                </span>
                <div className="underline-contact"></div>
                <p style={{ margin: "1rem 0 0 0" }}>{fileName}</p>
                <div className="lock-round"></div>
                <span className="manage-text">Manage Access</span>
              </div>
              <div className="general-access">
                <p className="view-edit" style={{ marginBottom: "2rem" }}>
                  General Access to view & edit
                </p>
                <div
                  className="roles-options roles-options-contact"
                  style={{
                    width: "100%",
                    display: "grid",
                    gridTemplateColumns: "repeat(4,1fr)",
                  }}
                >
                  <p
                    style={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56198"
                        ? {
                            backgroundColor: `${primaryColor}`,
                            fontSize: "18px",
                          }
                        : { backgroundColor: `#FFFFFF`, fontSize: "16px" }
                    }
                    className={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56198"
                        ? "role-single authorisation-roles active-role active-main"
                        : "role-single authorisation-roles "
                    }
                  >
                    owner
                  </p>
                  <p
                    style={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56199"
                        ? {
                            backgroundColor: `${primaryColor}`,
                            fontSize: "18px",
                          }
                        : { backgroundColor: ``, fontSize: "16px" }
                    }
                    className={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56199"
                        ? "role-single authorisation-roles active-role active-main"
                        : "role-single authorisation-roles "
                    }
                  >
                    manager
                  </p>
                  <p
                    style={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56200"
                        ? {
                            backgroundColor: `${primaryColor}`,
                            fontSize: "18px",
                          }
                        : { backgroundColor: ``, fontSize: "16px" }
                    }
                    className={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56200"
                        ? "role-single authorisation-roles active-role active-main"
                        : "role-single authorisation-roles "
                    }
                  >
                    user
                  </p>
                  <p
                    style={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56201"
                        ? {
                            backgroundColor: `${primaryColor}`,
                            fontSize: "18px",
                          }
                        : { backgroundColor: ``, fontSize: "16px" }
                    }
                    className={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56201"
                        ? "role-single authorisation-roles active-role active-main"
                        : "role-single authorisation-roles "
                    }
                  >
                    freelancer
                  </p>
                </div>
              </div>
              <div className="people-access general-access">
                <p className="view-edit">People with access</p>
                {docAccessList?.map((access, index) => {
                  return (
                    <div className="people-owner-flex" key={index}>
                      <div className="image-name-flex">
                        <img
                          src={access?.photo}
                          style={{ width: "35px", height: "35px" }}
                        />
                        <span className="name-flex">
                          <span>{access?.username}</span>
                          <span className="text-heading-styles">
                            {companyId ===
                              "28830f30-b321-4662-a576-f23451677733" &&
                              "Corporat Booking Desk"}
                            {companyId ===
                              "28830f30-b321-4662-a576-f23451677744" &&
                              "ZUID BEHEER"}
                            {companyId ===
                              "28830f30-b321-4662-a576-f23451677755" &&
                              "Residence 32"}
                          </span>
                        </span>
                      </div>
                      <div>
                        <select
                          key={index}
                          style={{ fontsize: "14px", width: "8rem" }}
                          className="input-style add-contact-input-style"
                          name="accesslevelid"
                          id="accesslevelid"
                          value={access.accesslevelid}
                          required
                        >
                          <option
                            value="08da33e9-5a64-4f8c-8d88-49e4982df321"
                            name="08da33e9-5a64-4f8c-8d88-49e4982df321"
                          >
                            View
                          </option>
                          <option
                            value="08da33e9-5a64-4f8c-8d88-49e4982df320"
                            name="08da33e9-5a64-4f8c-8d88-49e4982df320"
                          >
                            Edit
                          </option>
                          <option
                            value="08da33e9-5a64-4f8c-8d88-49e4982df323"
                            name="08da33e9-5a64-4f8c-8d88-49e4982df323"
                          >
                            Owner
                          </option>
                          <option
                            value="08da33e9-5a64-4f8c-8d88-49e4982df322"
                            name="08da33e9-5a64-4f8c-8d88-49e4982df322"
                          >
                            NA
                          </option>
                        </select>
                      </div>
                    </div>
                  );
                })}
                <div className="plus-icon-function">
                  <div className="plus-icon">
                    <AiOutlinePlus
                      onClick={() => setShowDropPeople(!showDropPeople)}
                      style={{
                        fontSize: "1.5rem",
                        marginTop: "4px",
                        color: "#A7A7A7",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  {showDropPeople && (
                    <div className="drop-down-plus" id="drop-down-plus">
                      <div className="search-div-people">
                        <input
                          type="text"
                          style={
                            searchPeople
                              ? { opacity: "100%" }
                              : { opacity: "50%" }
                          }
                          className="search-people-input"
                          placeholder="Search"
                          value={searchPeople}
                          onChange={(e) => {
                            setSearchPeople(e.target.value);
                          }}
                        />
                      </div>
                      {docPeopleList?.map((people, index) => {
                        const singlePeople = people.userdetails[0];
                        return (
                          <div key={index} className="peoples-flex">
                            <img
                              src={singlePeople.imageurl}
                              style={{ width: "30px", height: "30px" }}
                            />
                            <p style={{ marginBottom: "0" }}>
                              {singlePeople.firstname} {singlePeople.lastname}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          <div
            className={
              isUpdating
                ? "column-3-info ascHideForMobile"
                : "column-3-information ascHideForMobile"
            }
          >
            <div className="timeline-main-div" ref={refActivityTimelineDD}>
              <div className="heading-filter">
                <p className="activity-text" style={{ color: "#333333" }}>
                  {t("Activity Timeline")}
                </p>
                <img
                  src={actfilter}
                  alt="filter"
                  width="18px"
                  height="16px"
                  onClick={() => setFilterDrop(true)}
                  style={{
                    cursor: "pointer",
                  }}
                  className="responsive-check"
                />
                {/* <BiSliderAlt
                  onClick={() => setFilterDrop(true)}
                  style={{
                    // fontSize: "1.6rem",
                    color: `${primaryColor}`,
                    cursor: "pointer",
                  }}
                  className="responsive-check"
                /> */}
                {filterDrop && (
                  <div className="filter-drop">
                    <div
                      style={{
                        textAlign: "end",
                        marginRight: "0.9rem",
                        marginTop: "1rem",
                      }}
                    >
                      <AiOutlineCloseCircle
                        onClick={() => setFilterDrop(false)}
                        style={{
                          // fontSize: "1.25rem",
                          // color: "#707070",
                          cursor: "pointer",
                          fontSize: "23px",
                          color: "#a5a5a5",
                        }}
                      />
                    </div>
                    <div className="drop-option-grid">
                      {/* <SVGInformation className="responsive-check" /> */}
                      <img
                        src={actinfoblack}
                        className="responsive-check"
                        alt="mail"
                      />
                      <span>{t("Information")}</span>

                      <Radio
                        checked={selectedValue === "information"}
                        onChange={handleChange}
                        value="information"
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                        checkedIcon={<BpCheckedIcon />}
                        icon={<BpIcon />}
                        size="small"
                        disableRipple={true}
                        disableFocusRipple={true}
                        sx={{
                          ":hover": {
                            backgroundColor: "transparent",
                          },
                        }}
                      />
                      {/* <SVGDocuments className="responsive-check" /> */}
                      <img
                        src={actfold}
                        className="responsive-check"
                        alt="mail"
                        height="19px"
                        width="21px"
                      />
                      <span>{t("Documents")}</span>
                      <Radio
                        checked={selectedValue === "docs"}
                        onChange={handleChange}
                        value="docs"
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                        checkedIcon={<BpCheckedIcon />}
                        icon={<BpIcon />}
                        size="small"
                        disableRipple={true}
                        disableFocusRipple={true}
                        sx={{
                          ":hover": {
                            backgroundColor: "transparent",
                          },
                        }}
                        // {...props}
                      />
                      {/* <SVGTasks className="responsive-check" /> */}
                      <img
                        src={actclip}
                        className="responsive-check"
                        alt="mail"
                        height="22px"
                        width="18px"
                      />
                      <span>{t("Tasks")}</span>
                      <Radio
                        checked={selectedValue === "tasks"}
                        onChange={handleChange}
                        value="tasks"
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                        size="small"
                        disableRipple={true}
                        checkedIcon={<BpCheckedIcon />}
                        icon={<BpIcon />}
                        disableFocusRipple={true}
                        sx={{
                          ":hover": {
                            backgroundColor: "transparent",
                          },
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        className="reset-btn"
                        onClick={() => handleChange({ target: { value: "" } })}
                      >
                        {t("Reset default")}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="timeline-div">
                {activityLogs.length === 0 && (
                  <div
                    key={"no-data"}
                    className="d-flex  timeline-container"
                    style={{
                      "--themeColor": primaryColor,
                      overflow: auto,
                      minHeight: "600px",
                      maxHeight: "1000px",
                    }}
                  >
                    <div className="activity-icon"></div>
                    <div className="message-container">
                      <div className="d-flex flex-column message-box empty">
                        <div className="activity-message"></div>
                        <div className="activity-time"></div>
                      </div>
                    </div>
                  </div>
                )}
                {activityLogs.map((Log, index) => {
                  return (
                    <div
                      key={index}
                      className="d-flex align-items-center timeline-container"
                      style={{ "--themeColor": primaryColor }}
                    >
                      <div className="activity-icon">{Log.Icon}</div>
                      <div className="message-container">
                        <div className="d-flex flex-column message-box">
                          {showFullContent && showIndexContent === index ? (
                            <div
                              className="activity-message"
                              onClick={() => {
                                setShowFullContent(!showFullContent);
                              }}
                            >
                              {Log.message}
                            </div>
                          ) : (
                            <div
                              className="activity-message"
                              onClick={() => {
                                setShowIndexContent(index);
                                setShowFullContent(!showFullContent);
                              }}
                            >
                              {" "}
                              {Log.message.slice(0, 80)}
                              {Log.message.length > 80 && "..."}
                            </div>
                          )}
                          <div className="activity-time">{Log.time}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {/* add button for mobile view start */}
          <Row style={{ position: "fixed", bottom: "12px" }}>
            <Col
              xs={6}
              className="add-col-item d-none upperADD_CancelBtnShoeHide_Mobile"
            >
              <div
                className="d-flex cancel_cont_btn ms-4"
                onClick={() => {
                  handelCancel();
                }}
                style={{ borderRadius: "12px" }}
              >
                <p className="fw-bold mb-0" style={{ color: "#5b5b5b" }}>
                  {/* cancel */}
                  {t("Cancel")}
                </p>
              </div>
            </Col>
            <Col xs={6} className="d-none upperADD_CancelBtnShoeHide_Mobile">
              {removeaddbtn ? (
                <div
                  className="d-flex add-buttons ms-4"
                  style={{ borderRadius: "12px" }}
                  onClick={handleContactAdd}
                >
                  <p className="fw-bold mb-0">
                    {isUpdating
                      ? // ? "Confirm"
                        t("Confirm")
                      : t("Add")}
                  </p>
                </div>
              ) : (
                <div
                  className="d-flex add-buttons ms-4"
                  style={{ borderRadius: "12px" }}
                  onClick={handleContactAdd}
                >
                  <p className="fw-bold mb-0">
                    {isUpdating
                      ? // ? "Confirm"
                        t("Confirm")
                      : t("Add")}
                  </p>
                </div>
              )}
            </Col>
          </Row>
          {/* add button for mobile view end */}
        </section>
      </section>
      {/* {popups && (
        <Modal
          show={popups}
          // onHide={handleClose}
          // setpop={setPopups}
          className="modelwidth1"
          style={{
            backgroundColor: "transparent",
            opacity: 0.9,
            // display: "block"
          }}
        >
          <Modal.Body>
            <div className="flex_class my-5">
              <div className="text-danger">
                {fetchTransAddContactList[57]?.translation}
              </div>

              <div className=" mt-3">
                {" "}
                {fetchTransAddContactList[58]?.translation}
              </div>

              <div className="mt-5 ">
                <button
                  className="me-2 w-25 btn-no"
                  onClick={() => {
                    setPopups(false);
                    // window.location.reload();
                  }}
                >
                  {fetchTransAddContactList[59]?.translation}
                </button>
                <button
                  className="ms-2 w-25 btn-yes"
                  onClick={() => {
                    // setPopups(false);
                    history.push("/contact-list");
                    window.localStorage.removeItem("clientaddname");
                    window.localStorage.removeItem("clientId2");
                    window.localStorage.removeItem("_tmpCon");
                  }}
                >
                  {fetchTransAddContactList[60]?.translation}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )} */}
      {deleteModalShow && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteFun}
          show={deleteModalShow}
          onHide={() => setDeleteModalShow(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          title3={t("Do you want to proceed?")}
          no={t("No")}
          yes={t("Yes")}
        />
      )}
      {deleteDocument && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteDocumentFun}
          show={deleteDocument}
          onHide={() => setDeleteDocument(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          title3={t("Do you want to proceed?")}
          no={t("No")}
          yes={t("Yes")}
        />
      )}
      {/* </ThemeProvider> */}
    </>
  );
};

export default AddContacts;
